// Code generated by models2ts. DO NOT EDIT.
// no touchy por favor


// go/v2/addresses.go
export declare interface Address {
    id?: string;
    userID?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    company?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateID?: StateID;
    zip?: string;
    countryID?: CountryID;
    phone?: string;
    phoneMurmur?: number;
    email?: string;
    emailMurmur?: number;
    murmur?: number;
    sha3224?: string;
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    user?: User;
    country?: Country;
    state?: State;
    createdByUser?: User;
    updatedByUser?: User;
}

// go/v2/adminroles.go
export declare interface AdminRole {
    id?: AdminRoleID;
    name?: string;
    permissions?: string[];
    active?: boolean;
    created?: string;
    updated?: string;
}
export const AdminRoleID = {
    ADMIN_ROLES_ARTIST: 1,
    ADMIN_ROLES_SALES: 2,
    ADMIN_ROLES_FACTORY: 3,
    ADMIN_ROLES_IAP: 4,
    ADMIN_ROLES_MANAGER: 5,
    ADMIN_ROLES_DEVELOPER: 6,
    ADMIN_ROLES_FRONT_OFFICE: 7,
    ADMIN_ROLES_MARKETING: 9,
    ADMIN_ROLES_ART_DIRECTOR: 13,
    ADMIN_ROLES_COMMISSIONED: 17,
    ADMIN_ROLES_SMG_FACTORY: 21,
    ADMIN_ROLES_APO_SHIPPER: 22,
    ADMIN_ROLES_QUOTE_BIDDER: 23,
    ADMIN_ROLES_FACTORY_COMMUNICATIONS: 24,
    ADMIN_ROLES_ARTIST_STAT_VIEWER: 25,
} as const;
export type AdminRoleID = typeof AdminRoleID[keyof typeof AdminRoleID];

// go/v2/artistrewards.go
export declare interface ArtistRewards {
    id?: string;
    userID?: string;
    orderLineItemID?: string;
    points?: string;
    salesOverride?: boolean;
    noTasks?: boolean;
    orderID?: string;
    orderPending?: boolean;
    orderPendingUpdated?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    order?: Order;
    orderLineItem?: OrderLineItem;
    createdByUser?: User;
}

// go/v2/artworkgorups.go
export declare interface ArtworkGroup {
    artworkGroupID?: string;
    companyID?: string;
    name?: string;
    description?: string;
    tags?: string[];
    width?: number;
    height?: number;
    backgroundColor?: string;
    svgReColor?: string;
    quality?: number;
    webPQuality?: number;
    av1Quality?: number;
    open?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    company?: Realm;
    createdBy?: User;
}

// go/v2/artworkgroupimages.go
export declare interface ArtworkGroupImage {
    id?: string;
    artworkGroupID?: string;
    imageID?: string;
    name?: string;
    description?: string;
    url?: string;
    tags?: string[];
    groupTags?: string[];
    width?: number;
    height?: number;
    backgroundColor?: string;
    svgReColor?: string;
    quality?: number;
    webPQuality?: number;
    av1Quality?: number;
    format?: string;
    lineItemData?: {
        lineItemID?: string;
        lineItemTypeID?: string;
        lineItemTypeSizeID?: string;
        childLineItemData?: {
            childLineItemID?: string;
            childLineItemOptionID?: string;
        };
    };
    SortOrder?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    artworkGroup?: ArtworkGroup;
    image?: Image;
    createdBy?: User;
}

// go/v2/blanks.go
export declare interface Blank {
    id?: string;
    factoryID?: FactoryID;
    lineItemID?: LineItemID;
    name?: string;
    current?: number;
    pending?: number;
    sold?: number;
    type?: BlankType;
    backgroundColor?: string;
    finish?: string;
    vendor?: string;
    baseMetal?: string;
    memo?: string;
    sortOrder?: number;
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    latest?: boolean;
    factory?: Factory;
    lineItem?: LineItem;
    createdBy?: User;
    updatedBy?: User;
}
export const BlankType = {
    BLANK_TYPE_BLANK: "BLANK",
    BLANK_TYPE_MATERIAL: "MATERIAL",
} as const;
export type BlankType = typeof BlankType[keyof typeof BlankType];

// go/v2/blogcategories.go
export declare interface BlogCategory {
    id?: string;
    name?: string;
    created?: string;
    active?: boolean;
}

// go/v2/blogimages.go
export declare interface BlogImage {
    id?: string;
    networkID?: string;
    path?: string;
    name?: string;
    description?: string;
    files?: {
        Original: BlogImageFile;
        Thumbnail: BlogImageFile;
        Small: BlogImageFile;
        Medium: BlogImageFile;
        Large: BlogImageFile;
    };
    totalSize?: number;
    hash?: string;
    created?: string;
    active?: boolean;
}
export declare interface BlogImageFile {
    File: string;
    Size: number;
    Width: number;
    Height: number;
}

// go/v2/blogposts.go
export declare interface BlogPost {
    id?: string;
    companyID?: string;
    uploadID?: number;
    title?: string;
    author?: string;
    url?: string;
    slug?: string;
    html?: string;
    markdown?: string;
    published?: boolean;
    unlisted?: boolean;
    featured?: boolean;
    tags?: string[];
    category?: string;
    description?: string;
    productUploadIDs?: number[];
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    latest?: boolean;
    realm?: Realm;
    upload?: Upload;
    previous?: BlogPost[];
    productUploads?: Upload[];
}

// go/v2/blogs.go
export declare interface Blog {
    id?: string;
    draft?: boolean;
    companyID?: string;
    userID?: string;
    lastUserID?: string;
    blogCategoryID?: string;
    name?: string;
    description?: string;
    body?: string;
    permalink?: string;
    blogImageID?: string;
    tags?: string[];
    published?: boolean;
    googlePlusTitle?: string;
    googlePlusDescription?: string;
    twitterTitle?: string;
    twitterDescription?: string;
    facebookTitle?: string;
    facebookDescription?: string;
    publishedTime?: string;
    updated?: string;
    created?: string;
    active?: boolean;
    featured?: boolean;
    textContent?: string;
    idSHA256?: string;
    idMurmurHash3?: number;
    user?: User;
    blogCategory?: BlogCategory;
    blogImage?: BlogImage;
}

// go/v2/carriers.go
export declare interface Carrier {
    id?: CarrierID;
    name?: string;
    phone?: string;
    sortOrder?: number;
    link?: string;
    trackingSupported?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
}
export const CarrierID = {
    CARRIERS_DHL: 2,
    CARRIERS_FED_EX: 5,
    CARRIERS_OTHER: 1,
    CARRIERS_UPS: 4,
    CARRIERS_USPS: 3,
} as const;
export type CarrierID = typeof CarrierID[keyof typeof CarrierID];

// go/v2/cartitems.go
export declare interface CartItem {
    id?: string;
    cartID?: string;
    stockItemID?: string;
    quoteID?: string;
    orderID?: string;
    uploadID?: number;
    uploadLineItem?: CartItemUploadLineItem;
    quantity?: number;
    customizations?: { [key: string]: string};
    options?: CartItemOption[];
    active?: boolean;
    quantities?: { [key: string]: number};
    deletedLineItems?: string[];
    created?: string;
    subtotal?: string;
    total?: string;
    networkTotal?: string;
    maxNetworkTotal?: string;
    maxNetworkSubtotal?: string;
    quantityPricing?: { [key: number]: string};
    cart?: Cart;
    quote?: Quote;
    order?: Order;
    stockItem?: StockItem;
    upload?: Upload;
    cartItemUploads?: CartItemUpload[];
}
export declare interface CartItemUploadLineItem {
    name?: string;
    lineItemID?: LineItemID;
    lineItemTypeID?: LineItemTypeID;
    lineItemTypeSizeID?: string;
    childLineItems?: CartItemUploadChildLineItem[];
    price?: string;
}
export declare interface CartItemUploadChildLineItem {
    childLineItemID?: ChildLineItemID;
    childLineItemOptionID?: ChildLineItemOptionID;
    quantity?: number;
    price?: string;
}
export declare interface CartItemOption {
    name?: string;
    value?: string;
}

// go/v2/cartitemuploads.go
export declare interface CartItemUpload {
    id?: string;
    cartItemID?: string;
    uploadID?: number;
    tags?: string[];
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    cartItem?: CartItem;
    upload?: Upload;
    createdBy?: User;
}

// go/v2/cartorders.go
export declare interface CartOrder {
    id?: string;
    cartID?: string;
    orderID?: string;
    quantityIncreased?: boolean;
    quantityDecreased?: boolean;
    quantityChangeWorth?: string;
    quantityChanges?: CartOrderQuantityChange[];
    deletedLineItem?: boolean;
    quantityChangeAllowed?: boolean;
    createdByUserID?: string;
    companyID?: string;
    pageRequestID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orders?: Order[];
}
export declare interface CartOrderQuantityChange {
    id?: string;
    original?: number;
    new?: number;
}

// go/v2/carts.go
export declare interface Cart {
    id?: string;
    parentCartID?: string;
    userID?: string;
    companyID?: string;
    pageRequestID?: string;
    possibleUserID?: string;
    created?: string;
    name?: string;
    admin?: boolean;
    company?: Realm;
    user?: User;
    cartItems?: CartItem[];
    cartOrders?: CartOrder[];
}

// go/v2/changelog.go
export declare interface ModelChangelogEntry {
    userID: string;
    column: string;
    oldValue: unknown;
    newValue: unknown;
    time: string;
}

// go/v2/checkboxchecks.go
export declare interface CheckboxCheck {
    checkboxCode?: string;
    value?: string;
    bid2?: string;
    buuid?: string;
    checkbox?: Checkbox;
}

// go/v2/checkboxes.go
export declare interface Checkbox {
    checkboxCode?: string;
    userID?: string;
    checkboxChecks?: CheckboxCheck[];
}

// go/v2/childlineitemoptions.go
export declare interface ChildLineItemOption {
    id?: ChildLineItemOptionID;
    childLineItemID?: ChildLineItemID;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    default?: boolean;
    weight?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    networkChildLineItemOption?: NetworkChildLineItemOption;
}
export const ChildLineItemOptionID = {
    CHILD_LINE_ITEM_OPTION_COIN_MOLD_FEE_NEW_BOTH_SIDES: "FUGi6b6Z4YI",
    CHILD_LINE_ITEM_OPTION_COIN_MOLD_FEE_NEW_ONE_SIDE: "FUGi6b6aQ0I",
    CHILD_LINE_ITEM_OPTION_COIN_3_D_MOLD_FEE_NEW_BOTH_SIDES: "FUGi6b6ho_I",
    CHILD_LINE_ITEM_OPTION_COIN_3_D_MOLD_FEE_NEW_ONE_SIDE: "FUGi6b6hBBI",
    CHILD_LINE_ITEM_OPTION_MEDAL_MOLD_FEE_NEW_BOTH_SIDES: "GCOK6Gh1OhA",
} as const;
export type ChildLineItemOptionID = typeof ChildLineItemOptionID[keyof typeof ChildLineItemOptionID];

// go/v2/childlineitems.go
export declare interface ChildLineItem {
    id?: ChildLineItemID;
    lineItemID?: LineItemID;
    name?: string;
    pluralName?: string;
    description?: string;
    limit?: number;
    default?: boolean;
    autoQuantity?: boolean;
    linkedQuantity?: boolean;
    mold?: boolean;
    weight?: string;
    notShipped?: boolean;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItem?: LineItem;
    networkChildLineItem?: NetworkChildLineItem;
    childLineItemOptions?: ChildLineItemOption[];
}
export const ChildLineItemID = {
    CHILD_LINE_ITEM_COIN_MOLD_FEE: "FUGi9HupB5I",
    CHILD_LINE_ITEM_COIN_3_D_MOLD_FEE: "FUGi9HxVHJI",
    CHILD_LINE_ITEM_PIN_MOLD_FEE: "FUGi9HxFM8I",
    CHILD_LINE_ITEM_PIN_3_D_MOLD_FEE: "FUGi9HuUC6I",
} as const;
export type ChildLineItemID = typeof ChildLineItemID[keyof typeof ChildLineItemID];

// go/v2/commissiontotals.go
export declare interface CommissionTotal {
    id?: string;
    orderID?: string;
    managingCompanyID?: string;
    percentage?: string;
    orderCommission?: string;
    factoryCommission?: string;
    shippingCommission?: string;
    total?: string;
    created?: string;
}

// go/v2/commissiontransfers.go
export declare interface CommissionTransfer {
    id?: string;
    orderID?: string;
    managingCompanyID?: string;
    orderCommission?: string;
    factoryCommission?: string;
    shippingCommission?: string;
    total?: string;
    percentage?: string;
    transferred?: boolean;
    markedAsTransferred?: boolean;
    created?: string;
}

// go/v2/contacts.go
export declare interface Contact {
    id?: string;
    companyID?: string;
    userID?: string;
    name?: string;
    company?: string;
    email?: string;
    phone?: string;
    body?: string;
    remoteAddress?: string;
    referer?: string;
    spam?: boolean;
    created?: string;
}

// go/v2/countries.go
export declare interface Country {
    id?: CountryID;
    name?: string;
    countryCode2?: string;
    countryCode3?: string;
    sortOrder?: number;
    states?: State[];
}
export const CountryID = {
    COUNTRIES_UNITED_STATES: 235,
    COUNTRIES_PUERTO_RICO: 181,
    COUNTRIES_GUAM: 95,
    COUNTRIES_CHINA: 44,
    COUNTRIES_VIET_NAM: 242,
    COUNTRIES_BANGLADESH: 23,
} as const;
export type CountryID = typeof CountryID[keyof typeof CountryID];

// go/v2/customeremailattachments.go
export declare interface CustomerEmailAttachment {
    id?: string;
    customerEmailID?: string;
    name?: string;
    path?: string;
    size?: number;
    'sha3-224'?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    customerEmail?: CustomerEmail;
    createdBy?: User;
}

// go/v2/customeremails.go
export declare interface CustomerEmail {
    id?: string;
    companyID?: string;
    userID?: string;
    sentEmailID?: string;
    sentEmailCategoryID?: string;
    emailTemplate?: string;
    emailTypeID?: number;
    followUpID?: string;
    subject?: string;
    text?: string;
    html?: string;
    ids?: CustomerEmailIDs;
    sent?: number;
    bccCompany?: boolean;
    bccFrontOffice?: boolean;
    sendAfter?: string;
    allowHTML?: boolean;
    useMaster?: boolean;
    conditions?: unknown;
    emailTriggerID?: string;
    addresses?: CustomerEmailAddresses;
    version?: number;
    data?: unknown;
    sqsMsgGrpID?: number;
    dev?: boolean;
    createdByAdmin?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    realm?: Realm;
    user?: User;
    sentEmail?: SentEmail;
    emailType?: EmailType;
    createdBy?: User;
    customerEmailAttachments?: CustomerEmailAttachment[];
}
export declare interface CustomerEmailAddresses {
    to?: EmailAddresses;
    cc?: EmailAddresses;
    bcc?: EmailAddresses;
    replyTo?: EmailAddresses;
    from?: EmailAddresses;
}
export declare type EmailAddresses = { [key: string]: string};

export declare interface CustomerEmailIDs {
    userID?: string;
    orderID?: string;
    loginCodeID?: string;
    customerEmailID?: string;
    secondaryCustomerEmailID?: string;
    quoteSentInstanceID?: string;
    shipmentID?: string;
    shippingOptionID?: string;
    orderShippingOptionID?: string;
    orderShippingOptionShipmentID?: string;
    quoteRequestProjectTaskID?: string;
    quoteRequestProjectID?: string;
    quoteRequestID?: string;
    quoteID?: string;
    lineItemID?: string;
    pageRequestID?: string;
    linkID?: string;
    forgotPasswordKey?: string;
    userEventID?: string;
    promotionalCodeID?: string;
    cartID?: string;
}

// go/v2/details.go
export declare interface Detail {
    id?: string;
    json?: unknown;
    active?: boolean;
    created?: string;
    updated?: string;
}
export declare interface Details {
    defaultTaskTimeBudgets?: { [key: string]: { [key: string]: { [key: string]: number}}};
    defaultGoalPercentage?: string;
    goalAmount?: { [key: string]: {
        companyID: string;
        targetAmount: string;
    }[]};
    quotaAmount?: { [key: string]: {
        companyID: string;
        quotaAmount: string;
    }[]};
    grafanaDashboardTemplates?: { [key: string]: unknown};
}

// go/v2/emailtemplates.go
export declare interface EmailTemplate {
    id?: string;
    networkID?: string;
    companyID?: string;
    emailTypeID?: number;
    name?: string;
    subject?: string;
    text?: string;
    html?: string;
    sms?: string;
    version?: number;
    useMaster?: boolean;
    user?: string;
    updatedUser?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    emailType?: EmailType;
}

// go/v2/emailtypes.go
export declare interface EmailType {
    id?: number;
    name?: string;
    sparkPostPool?: string;
    from?: string;
    transactional?: boolean;
    sqsQueue?: string;
    userID?: string;
    created?: string;
    updated?: string;
}

// go/v2/factories.go
export declare interface Factory {
    id?: string;
    originalFactoryID?: string;
    countryID?: CountryID;
    productionSheetID?: string;
    nativeName?: string;
    name?: string;
    realName?: string;
    notes?: string;
    placeOrderEmails?: boolean;
    shippingFullName?: string;
    shippingCompany?: string;
    shippingPhone?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateID?: StateID;
    zip?: string;
    bidding?: boolean;
    qboVendorID?: string;
    shipExecName?: string;
    shipExecShipper?: string;
    upsAccountNumber?: string;
    lat?: number;
    lng?: number;
    kind?: string;
    supportedCarrierIDs?: CarrierID[];
    preferred?: FactoryPreferred;
    exclusions?: FactoryPreferred;
    exclusionsJS?: string;
    estimatedCapacity?: number;
    estimatedOrderCapacity?: number;
    paused?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    country?: Country;
    state?: State;
    factoryContacts?: FactoryContact[];
}
export declare interface FactoryPreferred {
    flagIDs?: FlagID[];
    lineItemIDs?: string[];
    lineItemTypeIDs?: string[];
    lineItemTypeSizeIDs?: string[];
    childLineItemIDs?: string[];
    childLineItemOptionIDs?: string[];
}
export const FactoryID = {
    FACTORY_SMG: "Flmb8bxscBg",
    FACTORY_MARTIN: "FrXw6GKlXas",
    FACTORY_DAVID_NING: "FU5zbPh5V6E",
    FACTORY_TONY_WANG: "FU5zbPh02AE",
    FACTORY_HELEN_BD: "F78vAIxSA-c",
    FACTORY_JENNY_HUANG_BD: "FxjE0JBEe4o",
    FACTORY_JIM_CEN_VN: "GBUaNe7LEhM",
    FACTORY_KAREN_BD: "F3f3rjuof2U",
    FACTORY_OWEN_BD: "Fe3amapI0FA",
    FACTORY_SPLIT_PAYMENT: "FZFuffkynIA",
    FACTORY_CANCELED: "FfRJe_CIcRA",
    FACTORY_EXPRESS_A_BUTTON: "FU5zbPh1e7E",
} as const;
export type FactoryID = typeof FactoryID[keyof typeof FactoryID];
export const FactoryKind = {
    FACTORY_KIND_FACTORY: "FACTORY",
    FACTORY_KIND_VENDOR: "MISC",
} as const;
export type FactoryKind = typeof FactoryKind[keyof typeof FactoryKind];

// go/v2/factorycontacts.go
export declare interface FactoryContact {
    id?: string;
    factoryID?: string;
    name?: string;
    phone?: string;
    email?: string;
    created?: string;
}

// go/v2/flagflags.go
export declare interface FlagFlag {
    id?: string;
    flagID?: FlagID;
    userID?: string;
    orderID?: string;
    quoteRequestProjectID?: string;
    pageRequestID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    createdByUser?: User;
    order?: Order;
    quoteRequestProject?: QuoteRequestProject;
    pageRequest?: PageRequest;
    flag?: Flag;
}

// go/v2/flags.go
export declare interface Flag {
    id?: FlagID;
    flagType?: string;
    name?: string;
    shortName?: string;
    description?: string;
    icon?: FlagIcons;
    sortOrder?: number;
    permissionJS?: string;
    color?: string;
    order?: boolean;
    user?: boolean;
    quoteRequestProject?: boolean;
    pageRequest?: boolean;
    active?: boolean;
    userEditable?: boolean;
    created?: string;
    updated?: string;
}
export declare interface FlagIcons {
    fa4?: FlagIcon;
    fa5?: FlagIcon;
}
export declare interface FlagIcon {
    class: string;
    style?: string;
}
export const FlagType = {
    FLAG_TYPE_ORDER: 1,
    FLAG_TYPE_USER: 2,
    FLAG_TYPE_QUOTE_REQUEST_PROJECT: 3,
    FLAG_TYPE_PAGE_REQUEST: 4,
} as const;
export type FlagType = typeof FlagType[keyof typeof FlagType];
export const FlagID = {
    FLAG_ACTIVE_ARTWORK: 1,
    FLAG_ACTIVE_REVISION: 16,
    FLAG_PENDING_RESPONSE: 17,
    FLAG_PENDING_FEEDBACK: 18,
    FLAG_RTO: 19,
    FLAG_ORDERING_INSTRUCTIONS_SENT: 20,
    FLAG_ON_HOLD: 21,
    FLAG_HOT: 22,
    FLAG_ORDERED: 23,
    FLAG_RUSH: 24,
    FLAG_UNQUALIFIED_LEAD: 25,
    FLAG_LOST_AND_REASON_PROVIDED: 26,
    FLAG_LOST_WITHOUT_REASON_PROVIDED: 27,
    FLAG_PENDING_DESIGN_APPROVAL: 28,
    FLAG_PENDING_FUNDS: 29,
    FLAG_DIFFICULT: 30,
    FLAG_KIND: 31,
    FLAG_MULTI_NETWORK: 32,
    FLAG_PREFERS_EMAIL: 33,
    FLAG_PREFERS_PHONE: 34,
    FLAG_REPEAT_CUSTOMER: 35,
    FLAG_RESPONSIVE: 36,
    FLAG_UNSUBSCRIBED: 37,
    FLAG_SHIP_TO_BUILDING: 38,
    FLAG_POOR_REVIEWER: 39,
    FLAG_RESELLER_BLIND_SHIP: 40,
    FLAG_VERIFIED: 42,
    FLAG_FACTORY_MISTAKE: 43,
    FLAG_SPELLING_MISTAKE: 44,
    FLAG_TOLERANCE_MISTAKE: 45,
    FLAG_LATE_ORDER: 46,
    FLAG_FUP: 47,
    FLAG_3_D_MOLD_APPROVAL: 48,
    FLAG_ART_PROBLEM: 49,
    FLAG_DONT_PAY_FACTORY_COST: 50,
    FLAG_DONT_PAY_EXTRA_SHIPPING: 51,
    FLAG_FACTORY_PRICING_MISTAKE: 52,
    FLAG_FUTURE_CREDIT_GIVEN: 53,
    FLAG_MISSING_PRODUCT: 54,
    FLAG_PACKAGE_LOST: 55,
    FLAG_PROBLEM_RESOLVED: 56,
    FLAG_PROMO_APPROVAL: 57,
    FLAG_QUALITY_PROBLEM: 58,
    FLAG_REMAKE_REQUIRED: 59,
    FLAG_REORDER: 60,
    FLAG_SALES_TEAM_MISTAKE: 61,
    FLAG_SHIPPING_MISTAKES: 62,
    FLAG_STOCK_ITEMS: 63,
    FLAG_WAITING_ON_SALES: 64,
    FLAG_EVENT: 65,
    FLAG_DOMESTIC_PRODUCTION_PREFERENCE: 66,
    FLAG_ARTISTS_REWARDED: 67,
    FLAG_COMPLETELY_UNDERSTANDING: 68,
    FLAG_NOT_HAPPY: 69,
    FLAG_UPSET: 70,
    FLAG_FIRM_DATE: 71,
    FLAG_LIVID: 72,
    FLAG_CANCEL_AND_CREDIT: 73,
    FLAG_DELIVERED: 74,
    FLAG_PROJECT_ON_HOLD: 75,
    FLAG_SAMPLE_REQUEST: 76,
    FLAG_SAMPLE_PHOTOGRAPHED: 77,
    FLAG_SAMPLE_RECEIVED: 78,
    FLAG_PO_APPROVED: 79,
    FLAG_NO_FOLLOW_UPS: 106,
    FLAG_PREFERS_SMS: 111,
    FLAG_DOD_DOWNLOAD_GUIDE_GENERIC: 2865,
    FLAG_DOD_DOWNLOAD_GUIDE_COIN: 2866,
    FLAG_DOD_DOWNLOAD_GUIDE_BELT_BUCKLE: 2867,
    FLAG_DOD_DOWNLOAD_GUIDE_DOG_TAG: 2868,
    FLAG_DOD_DOWNLOAD_GUIDE_BOTTLE_OPENER: 2869,
    FLAG_DOD_DOWNLOAD_GUIDE_TIPS_AND_TRICKS: 2870,
    FLAG_IGNORE_SAMPLE_PHOTOS: 3236,
    FLAG_ENGAGED_AFTER_QUOTE: 3658,
} as const;
export type FlagID = typeof FlagID[keyof typeof FlagID];
export const FlagCategory = {
    FLAG_CATEGORY_JOURNEY_STEP: "Journey Step",
    FLAG_CATEGORY_CHARACTERISTIC: "Characteristic",
    FLAG_CATEGORY_MISTAKES: "Mistakes",
    FLAG_CATEGORY_REMINDERS: "Reminders",
    FLAG_CATEGORY_ACCOUNTING: "Accounting",
    FLAG_CATEGORY_MARKETING: "Marketing",
    FLAG_CATEGORY_SOURCING: "Sourcing",
    FLAG_CATEGORY_CUSTOMER_SENTIMENT: "Customer Sentiment",
} as const;
export type FlagCategory = typeof FlagCategory[keyof typeof FlagCategory];
export const FlagFor = {
    FLAG_FOR_ORDER: "order",
    FLAG_FOR_USER: "user",
    FLAG_FOR_QUOTE_REQUEST_PROJECT: "quoteRequestProject",
    FLAG_FOR_PAGE_REQUEST: "pageRequest",
} as const;
export type FlagFor = typeof FlagFor[keyof typeof FlagFor];

// go/v2/followups.go
export declare interface FollowUp {
    id?: string;
    followUpAltID?: number;
    followUpTemplateID?: string;
    name?: string;
    subject?: string;
    html?: string;
    text?: string;
    sendAfter?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
}
export declare interface ContactedFollowUp {
    id?: string;
    companyID?: string;
    multiNetwork?: boolean;
    sharedPhone?: boolean;
    verified?: boolean;
    proofs?: {
        file?: string;
        path?: string;
        cloudfront?: string;
        name: string;
        thumb: string;
        main: string;
    }[];
    total?: string;
    quoteSerial?: string;
    quoteProjectName?: string;
    eventDate?: string;
    dateNeeded?: string;
    latestContactedRX?: {
        time?: string;
        kind?: string;
    };
    latestContactedTX?: {
        time?: string;
        kind?: string;
    };
    possibleLatestContactedBody?: {
        trimmed?: string;
        raw?: string;
    };
    possibleLatestContactedSubject?: string;
    user?: User;
    realm?: Realm;
}

// go/v2/followuptemplates.go
export declare interface FollowUpTemplate {
    id?: string;
    networkID?: string;
    origin?: string;
    name?: string;
    subject?: string;
    content?: string;
    contentType?: string;
    sendFlags?: number;
    lastUsed?: string;
    useMaster?: boolean;
    sendInvoices?: string;
    version?: number;
    companyIDs?: string[];
    page?: string;
    html?: string;
    text?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
}

// go/v2/galleries.go
export declare interface Gallery {
    id?: string;
    networkID?: string;
    name?: string;
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    network?: Network;
    createdBy?: User;
    updatedBy?: User;
    galleryUploads?: GalleryUpload[];
}

// go/v2/galleryuploads.go
export declare interface GalleryUpload {
    id?: string;
    galleryID?: string;
    uploadID?: number;
    name?: string;
    details?: GalleryUploadDetails;
    sortOrder?: number;
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    gallery?: Gallery;
    upload?: Upload;
}
export declare interface GalleryUploadDetails {
    invoiceNumber?: number;
    lineItem?: string;
    type?: string;
    size?: string;
    plating?: string;
    edge?: string;
    industry?: string;
    attachment?: string;
    lanyardColor?: string;
    manufacturingLocation?: string;
    is3d?: boolean;
}

// go/v2/helpscoutwebhooks.go
export declare interface HelpScoutWebhook {
    id?: string;
    event?: string;
    json?: unknown;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/images.go
export declare interface Image {
    id?: string;
    path?: string;
    name?: string;
    files?: ImageFiles;
    totalSize?: number;
    'sha3-224'?: string;
    text?: string;
    hasRekognition?: boolean;
    hasRaster?: boolean;
    companyID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    proof?: Proof;
    company?: Realm;
    createdBy?: User;
    imageRekognitionLabels?: ImageRekognitionLabel[];
}
export declare interface ImageFile {
    File?: string;
    'SHA3-224'?: string;
    Size?: number;
    Width?: number;
    Height?: number;
    Mime?: string;
}
export declare interface ImageFiles {
    Large?: ImageFile;
    Large2x?: ImageFile;
    LargeWebP?: ImageFile;
    LargeWebP2x?: ImageFile;
    LargeAV1?: ImageFile;
    LargeAV12x?: ImageFile;
    Main?: ImageFile;
    Main2x?: ImageFile;
    MainWebP?: ImageFile;
    MainWebP2x?: ImageFile;
    MainAV1?: ImageFile;
    MainAV12x?: ImageFile;
    Original?: ImageFile;
    Raster?: ImageFile;
    Thumbnail?: ImageFile;
}
export declare interface ImageRekognitionLabel {
    id?: number;
    imageID?: string;
    label?: string;
    moderation?: boolean;
    confidence?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    image?: Image;
}

// go/v2/invoicetemplates.go
export declare interface InvoiceTemplate {
    id?: string;
    name?: string;
    body?: string;
    active?: boolean;
    created?: string;
    networkInvoiceTemplates?: NetworkInvoiceTemplate[];
}

// go/v2/lineitems.go
export declare interface LineItem {
    id?: LineItemID;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    tax?: boolean;
    shipping?: boolean;
    product?: boolean;
    factories?: boolean;
    sortOrder?: number;
    mold?: boolean;
    customsDescription?: string;
    harmonizedCode?: string;
    taxJarCode?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    networkLineItem?: NetworkLineItem;
    lineItemTypes?: LineItemType[];
    childLineItems?: ChildLineItem[];
}
export const LineItemID = {
    LINE_ITEMS_LAPEL_PIN: "FUGjGOoc0LI",
    LINE_ITEMS_BELT_BUCKLE: "FUGjGOoeNbI",
    LINE_ITEMS_BUTTON: "FUGjGOoerjI",
    LINE_ITEMS_CHALLENGE_COIN: "FUGjGOofEAI",
    LINE_ITEMS_CHARM: "FUGjGOofbSI",
    LINE_ITEMS_KEY_CHAIN: "FUGjGOofw9I",
    LINE_ITEMS_LANYARD: "FUGjGOogHBI",
    LINE_ITEMS_MEDAL: "FUGjGOogc6I",
    LINE_ITEMS_PATCH: "FUGjGOogxzI",
    LINE_ITEMS_POKER_CHIP: "FUGjGOohGpI",
    LINE_ITEMS_STICKER: "FUGjGOohb8I",
    LINE_ITEMS_T_SHIRT: "FUGjGOohxiI",
    LINE_ITEMS_WRIST_BAND: "FUGjGOoiGgI",
    LINE_ITEMS_STOCK_ITEM: "FUGjGOoibbI",
    LINE_ITEMS_FED_EX_SHIPPING: "FUGjGOoiwcI",
    LINE_ITEMS_UPS_SHIPPING: "FUGjGOojFoI",
    LINE_ITEMS_SALES_TAX: "FUGjGOojaFI",
    LINE_ITEMS_SALES_TAX_EXEMPT: "FUGjGOojvOI",
    LINE_ITEMS_RUSH_FEE: "FUGjGOokbII",
    LINE_ITEMS_DISCOUNT: "FUGjGOokv5I",
    LINE_ITEMS_SHIPPING: "FUGjGOolGJI",
    LINE_ITEMS_PRE_PRODUCTION_SAMPLING_FEE: "FUGjGOola7I",
    LINE_ITEMS_FACTORY_COST_ADJUSTMENT: "FVD-wKN_PRQ",
    LINE_ITEMS_ORNAMENT: "FWsNT7IuKIQ",
    LINE_ITEMS_ROUNDING_ADJUSTMENT: "FW0-C3uLcqA",
    LINE_ITEMS_STORE_CREDIT: "FYa0LGTO2iI",
    LINE_ITEMS_FACTORY_SHIPPING_CHARGES: "FZm8uAxzgdA",
    LINE_ITEMS_PROMO_CODE: "FZpEpKIHhZA",
    LINE_ITEM_STL_FILE: "GDmNno1XrTw",
} as const;
export type LineItemID = typeof LineItemID[keyof typeof LineItemID];

// go/v2/lineitemtypes.go
export declare interface LineItemType {
    id?: LineItemTypeID;
    lineItemID?: LineItemID;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    fridayLineItemNameOverride?: boolean;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItem?: LineItem;
    networkLineItemType?: NetworkLineItemType;
    lineItemTypeSizes?: LineItemTypeSize[];
}
export const LineItemTypeID = {
    LINE_ITEM_TYPE_LAPEL_PIN_DIE_STRUCK: "FUGjIgHrngI",
    LINE_ITEM_TYPE_LAPEL_PIN_SOFT_ENAMEL: "FUGjIgHow9I",
    LINE_ITEM_TYPE_PATCH_100_PERCENT_EMBROIDERY: "FUGjIgHgKSI",
    LINE_ITEM_TYPE_PATCH_75_PERCENT_EMBROIDERY: "FUGjIgHxRsI",
    LINE_ITEM_TYPE_LANYARD_IMPRINTED_POLYESTER: "FUGjIgH6YvI",
    LINE_ITEM_TYPE_LANYARD_IMPRINTED_TUBE: "FUGjIgH8ifI",
    LINE_ITEM_TYPE_LANYARD_WOVEN_POLYESTER: "FUGjIgHsVAI",
} as const;
export type LineItemTypeID = typeof LineItemTypeID[keyof typeof LineItemTypeID];

// go/v2/lineitemtypesizes.go
export declare interface LineItemTypeSize {
    id?: string;
    lineItemTypeID?: LineItemTypeID;
    width?: string;
    height?: string;
    type?: string;
    weight?: string;
    name?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItemType?: LineItemType;
    networkLineItemTypeSize?: NetworkLineItemTypeSize;
}

// go/v2/links.go
export declare interface Link {
    id?: string;
    linkCode?: number;
    imageID?: string;
    name?: string;
    companyID?: string;
    requestURI?: string;
    path?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    realm?: Realm;
}

// go/v2/managingcompanies.go
export declare interface ManagingCompany {
    id?: string;
    name?: string;
    created?: string;
    active?: boolean;
}

// go/v2/networkchildlineitemoptions.go
export declare interface NetworkChildLineItemOption {
    id?: string;
    networkID?: string;
    childLineItemOptionID?: string;
    networkSKUID?: string;
    name?: string;
    pluralName?: string;
    description?: string;
    price?: string;
    enabled?: boolean;
    sortOrder?: number;
    priceJS?: string;
}

// go/v2/networkchildlineitems.go
export declare interface NetworkChildLineItem {
    id?: string;
    networkID?: string;
    childLineItemID?: string;
    networkSKUID?: string;
    name?: string;
    pluralName?: string;
    description?: string;
    price?: string;
    enabled?: boolean;
    quoteForm?: boolean;
    builder?: boolean;
    sortOrder?: number;
    priceJS?: string;
}

// go/v2/networkinvoicetemplates.go
export declare interface NetworkInvoiceTemplate {
    id?: string;
    invoiceTemplateID?: string;
    created?: string;
    network?: Network;
    invoiceTemplate?: InvoiceTemplate;
}

// go/v2/networklineitems.go
export declare interface NetworkLineItem {
    id?: string;
    networkID?: string;
    lineItemID?: string;
    networkSKUID?: string;
    name?: string;
    pluralName?: string;
    sortOrder?: number;
    enabled?: boolean;
}

// go/v2/networklineitemtypes.go
export declare interface NetworkLineItemType {
    id?: string;
    networkID?: string;
    lineItemID?: string;
    name?: string;
    pluralName?: string;
    sortOrder?: number;
    enabled?: boolean;
}

// go/v2/networklineitemtypesizequantityprices.go
export declare interface NetworkLineItemTypeSizeQuantityPrice {
    id?: string;
    networkID?: string;
    lineItemTypeSizeID?: string;
    quantity?: number;
    price?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    network?: Network;
    lineItemTypeSize?: LineItemTypeSize;
}

// go/v2/networklineitemtypesizes.go
export declare interface NetworkLineItemTypeSize {
    id?: string;
    networkID?: string;
    lineItemID?: string;
    name?: string;
    enabled?: boolean;
    prices?: NetworkLineItemTypeSizeQuantityPrice[];
}

// go/v2/networks.go
export declare interface Network {
    id?: string;
    number?: number;
    name?: string;
    nameShort?: string;
    icon?: string;
    iconUnicode?: string;
    iconFA5?: string;
    color?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    zip?: string;
    stateID?: StateID;
    countryID?: CountryID;
    cloudFront?: string;
    bucket?: string;
    phoneFormat?: string;
    processorName?: string;
    reCaptchaSiteKey?: string;
    reCaptchaSecretKey?: string;
    shortDomain?: string;
    state?: State;
    country?: Country;
    companies?: Realm[];
    networkInvoiceTemplates?: NetworkInvoiceTemplate[];
}
export const NetworkID = {
    NETWORKS_1800_MY_BUTTONS: "FUGkiMh1fxI",
    NETWORKS_ALL_ABOUT_NETWORK_LLC: "FUGkiMh0eZI",
    NETWORKS_CHALLENGE_COIN_NATION_LLC: "FUGkiMhyDPI",
    NETWORKS_CITY_PROMOTIONS_LLC: "FUGkiMhyfTI",
    NETWORKS_GRANT: "FUGkiMhwFrI",
    NETWORKS_LAPEL_PINS_EXPRESS_LLC: "FUGkiMhzslI",
    NETWORKS_LEE: "FUGkiMh16LI",
    NETWORKS_SIGNATURE_PROMOTIONAL_GROUP_LLC: "FUGkiMh0GfI",
    NETWORKS_STERLING_MARKETING_GROUP_LLC: "FUGkiMh3bNI",
    NETWORKS_THE_LAPEL_PINAND_BUTTON_COMPANY_LLC: "FUGkiMh3DzI",
    NETWORKS_THE_LAPEL_PINS_PLUS_NETWORK_LLC: "FUGkiMh01xI",
    NETWORKS_THE_PIN_DEPOT_NETWORK_LLC: "FUGkiMhy53I",
    NETWORKS_TNG_CONSOLIDATED_LLC: "FUGkiMhxhFI",
    NETWORKS_TRADING_PINS_COM_LLC: "FUGkiMhzUeI",
    NETWORKS_USDOD_COINS_LLC: "FUGkiMh2r-I",
    NETWORKS_USA_NETWORK_LLC: "FUGkiMh2U3I",
} as const;
export type NetworkID = typeof NetworkID[keyof typeof NetworkID];

// go/v2/nodes.go
export declare interface NodeFlow {
    id?: string;
    name?: string;
    nodes?: Nodes;
    entrypoints?: string;
    enabled?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    instanceCount?: number;
    inProgressInstanceCount?: number;
    abortedInstanceCount?: number;
    finishedInstanceCount?: number;
    createdBy?: User;
}
export declare interface NodeFlowInstance {
    id?: string;
    parentNodeFlowInstanceID?: string;
    nodeFlowID?: string;
    context?: NodeContext;
    currentNodeID?: number;
    waitUntil?: string;
    aborted?: boolean;
    createdByUserID?: string;
    created?: string;
    updatedByUserID?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    latest?: boolean;
    nodeFlow?: NodeFlow;
    createdBy?: User;
    updatedBy?: User;
}
export const NodeName = {
    NODE_TIME: "time",
    NODE_BUTTON: "button",
    NODE_WEBHOOK: "webhook",
    NODE_GET_USERS: "get-users",
    NODE_UPDATE_USERS: "update-users",
    NODE_USER_CREATED: "user-created",
    NODE_USER_SALES_TEAM_UPDATED: "user-sales-team-updated",
    NODE_CREATE_USER: "create-user",
    NODE_FLAG_CREATED: "flag-created",
    NODE_FLAG_UPDATED: "flag-updated",
    NODE_FLAG_DELETED: "flag-deleted",
    NODE_ORDER_FLAG_CREATED: "order-flag-created",
    NODE_USER_FLAG_CREATED: "user-flag-created",
    NODE_QUOTE_REQUEST_PROJECT_FLAG_CREATED: "quote-request-project-flag-created",
    NODE_PAGE_REQUEST_FLAG_CREATED: "page-request-flag-created",
    NODE_ORDER_FLAG_DELETED: "order-flag-deleted",
    NODE_USER_FLAG_DELETED: "user-flag-deleted",
    NODE_QUOTE_REQUEST_PROJECT_FLAG_DELETED: "quote-request-project-flag-deleted",
    NODE_PAGE_REQUEST_FLAG_DELETED: "page-request-flag-deleted",
    NODE_SLEEP: "sleep",
    NODE_JS: "js",
    NODE_HELP_SCOUT_CUSTOMER_CREATED: "helpscout-customer-created",
    NODE_HELP_SCOUT_CUSTOMER_UPDATED: "helpscout-customer-updated",
    NODE_HELP_SCOUT_CONVERSATION_CREATED: "helpscout-conversation-created",
    NODE_HELP_SCOUT_CONVERSATION_WE_REPLIED: "helpscout-conversation-we-replied",
    NODE_HELP_SCOUT_CONVERSATION_CUSTOMER_REPLIED: "helpscout-conversation-customer-replied",
    NODE_GET_HELP_SCOUT_CONVERSATION: "get-helpscout-conversation",
    NODE_GET_HELP_SCOUT_CUSTOMER: "get-helpscout-customer",
    NODE_UPDATE_HELP_SCOUT_CONVERSATION: "update-helpscout-conversation",
    NODE_GET_HELP_SCOUT_FIRST_CONVERSATION: "get-helpscout-first-conversation",
    NODE_GET_HELP_SCOUT_CONVERSATIONS: "get-helpscout-conversations",
    NODE_GET_HELP_SCOUT_CONVERSATION_I_DS: "get-helpscout-conversation-ids",
    NODE_USER_RX: "user-rx",
    NODE_USER_TX: "user-tx",
    NODE_GET_USER_FROM_HELP_SCOUT_CUSTOMER_ID: "get-user-from-helpscout-customer-id",
    NODE_GET_SALES_TEAMS: "get-sales-teams",
    NODE_GET_QUOTE_REQUEST_PROJECTS: "get-quote-request-projects",
    NODE_UPDATE_QUOTE_REQUEST_PROJECTS: "update-quote-request-projects",
    NODE_CREDIT_CARD_DECLINED: "credit-card-declined",
    NODE_SEND_EMAIL: "send-email",
    NODE_SEND_SMS: "send-sms",
    NODE_LOGIN_CODE_CREATED: "login-code-created",
    NODE_CART_ITEM_CREATED: "cart-item-created",
    NODE_ORDER_CREATED: "order-created",
    NODE_CUSTOMER_REVISION_REQUEST_CREATED: "customer-revision-request-created",
    NODE_QUOTE_REQUEST_CREATED: "quote-request-created",
    NODE_SHIPPING_OPTION_CREATED: "shipping-option-created",
    NODE_PAYMENT_OPTION_CREATED: "payment-option-created",
    NODE_PAYMENT_OPTION_UPDATED: "payment-option-updated",
    NODE_QUOTE_SENT_INSTANCE_CREATED: "quote-sent-instance-created",
    NODE_ORDER_PLACED_WITH_FACTORY: "order-placed-with-factory",
    NODE_ORDER_MOVED_FROM_PENDING: "order-moved-from-pending",
    NODE_ORDER_PAYMENT_CREATED: "order-payment-created",
    NODE_FORGOT_PASSWORD_CREATED: "forgot-password-created",
    NODE_SHIPMENT_SHIPPED: "shipment-shipped",
    NODE_SHIPMENT_DELIVERED: "shipment-delivered",
    NODE_SHIPMENT_EXCEPTION: "shipment-exception",
    NODE_SHIPMENT_OUT_FOR_DELIVERY: "shipment-out-for-delivery",
    NODE_ORDER_LINE_ITEM_STAGE_CREATED: "order-line-item-stage-created",
    NODE_ORDER_LINE_ITEM_STAGE_COMPLETED: "order-line-item-stage-completed",
    NODE_CUSTOMER_EMAIL_SENT: "customer-email-sent",
    NODE_CUSTOMER_EMAIL_CREATED: "customer-email-created",
    NODE_UPLOAD_KEPT: "upload-kept",
    NODE_UPDATE_UPLOAD_META: "upload-update-meta",
    NODE_IMAGE_CREATED: "image-created",
    NODE_UPDATE_IMAGE_REKOGNITION: "image-update-rekognition",
    NODE_GET_REALMS: "get-realms",
    NODE_GET_ORDER_INVOICE: "get-order-invoice",
    NODE_GET_QUOTE_INVOICE: "get-quote-invoice",
    NODE_HTML_TO_PDF: "html-to-pdf",
    NODE_GET_ORDERS: "get-orders",
    NODE_GET_QUOTES: "get-quotes",
    NODE_NEW_QUOTE_SENTS: "new-quote-sents",
    NODE_NEW_FLAGS: "new-flags",
    NODE_DELETE_FLAGS: "delete-flags",
    NODE_USER_HAS_FLAG: "user-has-flag",
    NODE_ORDER_HAS_FLAG: "order-has-flag",
    NODE_ORDER_EVENT_CREATED: "order-event-created",
    NODE_GET_ORDER_EVENTS: "get-order-events",
    NODE_GET_FLAGS: "get-flags",
    NODE_GET_FLAG_FLAGS: "get-flag-flags",
    NODE_ORDER_TAX_JAR_SYNC: "order-tax-jar-sync",
    NODE_SHIPPING_OPTION_UPDATED: "shipping-option-updated",
    NODE_ORDER_SHIPPING_OPTION_UPDATED: "order-shipping-option-updated",
    NODE_ORDER_TOTAL_UPDATED: "order-total-updated",
    NODE_ORDER_TOTAL_SANS_TAX_UPDATED: "order-total-sans-tax-updated",
    NODE_ORDER_FACTORY_COST_UPDATED: "order-factory-cost-updated",
    NODE_USER_TAX_EXEMPTION_ORDER_CREATED: "user-tax-exemption-order-created",
    NODE_USER_TAX_EXEMPTION_ORDER_DELETED: "user-tax-exemption-order-deleted",
    NODE_USER_TAX_EXEMPTION_CREATED: "user-tax-exemption-created",
    NODE_USER_TAX_EXEMPTION_UPDATED: "user-tax-exemption-updated",
    NODE_USER_TAX_EXEMPTION_DELETED: "user-tax-exemption-deleted",
    NODE_ORDER_SHIPPING_OPTION_CREATED: "order-shipping-option-created",
    NODE_ORDER_SHIPPING_OPTION_DELETED: "order-shipping-option-deleted",
    NODE_SHIPPING_OPTION_DELETED: "shipping-option-deleted",
    NODE_GET_SHIPPING_OPTIONS: "get-shipping-options",
    NODE_GET_USER_TAX_EXEMPTIONS: "get-user-tax-exemptions",
    NODE_ORDER_ACTIVE_UPDATED: "order-active-updated",
    NODE_ORDER_PENDING_UPDATED: "order-pending-updated",
    NODE_ORDER_DELETED: "order-deleted",
    NODE_ORDER_RESTORED: "order-restored",
    NODE_ORDER_PLACE_ORDER_UPDATED: "order-place-order-updated",
    NODE_ORDER_PLACE_ORDER_REMIND_UPDATED: "order-place-order-remind-updated",
    NODE_ORDER_LATE_ORDER_IGNORED_UPDATED: "order-late-order-ignored-updated",
    NODE_ORDER_MARKED_AS_SHIPPED_UPDATED: "order-marked-as-shipped-updated",
    NODE_ORDER_MARKED_AS_SHIPPED: "order-marked-as-shipped",
    NODE_ORDER_FACTORY_CONFIRMED_SHIP_DATE_UPDATED: "order-factory-confirmed-ship-date-updated",
    NODE_ORDER_UNSHIPPED_SORT_ORDER_UPDATED: "order-unshipped-sort-order-updated",
    NODE_ORDER_ORDER_STATUS_UPDATED: "order-order-status-updated",
    NODE_ORDER_PLACED: "order-placed",
    NODE_ORDER_FACTORY_UPDATED: "order-factory-updated",
    NODE_ORDER_FACTORY_CANCELED: "order-factory-canceled",
    NODE_ORDER_COMPANY_UPDATED: "order-company-updated",
    NODE_ORDER_LINE_ITEMS_UPDATED: "order-line-items-updated",
    NODE_PURGE_NOTIFICATIONS: "delete-old-notifications",
    NODE_PURGE_DATA_TABLES: "delete-old-datatables",
    NODE_ORDER_SHIPPING_ACCOUNT_UPDATED: "order-shipping-account-updated",
    NODE_ORDER_SALES_TEAM_UPDATED: "order-sales-team-updated",
    NODE_ORDER_BIDS_NEEDED_UPDATED: "order-bids-needed-updated",
    NODE_ORDER_UPDATED_BY_USER_UPDATED: "order-updated-by-user-updated",
    NODE_ORDER_SALES_USER_UPDATED: "order-sales-user-updated",
    NODE_ORDER_FACTORY_SHIP_DATE_UPDATED: "order-factory-ship-date-updated",
    NODE_GET_FACTORIES: "get-factories",
    NODE_ORDER_UPDATED: "order-updated",
    NODE_ORDER_RESET_TOTALS: "order-reset-totals",
    NODE_ORDER_ORDER_LINE_ITEM_LINE_ITEM_UPDATED: "order-order-line-item-line-item-updated",
    NODE_ORDER_ORDER_LINE_ITEM_QUANTITY_UPDATED: "order-order-line-item-quantity-updated",
    NODE_ORDER_ORDER_LINE_ITEM_PRICE_UPDATED: "order-order-line-item-price-updated",
    NODE_ORDER_ORDER_LINE_ITEM_ACTIVE_UPDATED: "order-order-line-item-active-updated",
    NODE_ORDER_SHIPPING_OPTION_SHIPPING_OPTION_UPDATED: "order-shipping-option-shipping-option-updated",
    NODE_ORDER_ORDER_LINE_ITEM_CREATED: "order-order-line-item-created",
    NODE_IMPORT_NEW_SHIPPING_INVOICES: "import-new-shipping-invoices",
    NODE_GET_CUSTOMER_EMAILS: "get-customer-emails",
    NODE_GET_USER_EVENTS: "get-user-events",
    NODE_USER_EVENT_UPLOAD_DELETED: "user-event-upload-deleted",
    NODE_USER_EVENT_DELETED: "user-event-deleted",
    NODE_UPDATE_USER_EVENTS: "update-user-events",
    NODE_USER_EVENTS_UPDATED: "user-events-updated",
    NODE_USER_EVENTS_DELETED: "user-events-deleted",
    NODE_PURGE_NODE_FLOW_INSTANCES: "purge-node-flow-instances",
    NODE_NEW_PROMOTIONAL_CODES: "new-promotional-codes",
    NODE_GET_PROMOTIONAL_CODES: "get-promotional-codes",
    NODE_PAYMENT_OPTION_DELETED: "payment-option-deleted",
    NODE_GET_ORDER_TAXES: "get-order-taxes",
    NODE_CONTACT_CREATED: "contact-created",
    NODE_PODIUM_IMPORT_MESSAGE: "podium-import-message",
    NODE_PODIUM_UPDATE_CONVERSATION: "podium-update-conversation",
    NODE_PODIUM_ENABLED: "podium-enabled",
    NODE_UPDATE_ORDERS: "update-orders",
    NODE_UPDATE_ORDER: "update-order",
    NODE_UPDATE_ORDER_EVENTS: "update-order-events",
    NODE_UPDATE_ORDER_EVENT: "update-order-event",
    NODE_ORDER_EVENT_APPROVED: "order-event-approved",
    NODE_NEW_ORDER_EVENTS: "new-order-events",
    NODE_PODIUM_MESSAGE_SENT: "podium-message-sent",
    NODE_PODIUM_MESSAGE_FAILED: "podium-message-failed",
    NODE_PODIUM_MESSAGE_RECEIVED: "podium-message-received",
    NODE_PODIUM_CONTACT_CREATED: "podium-contact-created",
    NODE_PODIUM_CONTACT_UPDATED: "podium-contact-updated",
    NODE_PODIUM_CONTACT_DELETED: "podium-contact-deleted",
    NODE_PODIUM_CREATE_CONTACT_TAG: "podium-create-contact-tag",
    NODE_PODIUM_DELETE_CONTACT_TAG: "podium-delete-contact-tag",
    NODE_PODIUM_GET_CONTACT: "podium-get-contact",
    NODE_GET_QUOTE_SENTS: "get-quote-sents",
    NODE_QUOTE_REQUEST_UPDATED: "quote-request-updated",
    NODE_GET_QUOTE_REQUESTS: "get-quote-requests",
    NODE_QUOTE_REQUEST_ACTIVE_UPDATED: "quote-request-active-updated",
    NODE_USER_ADDED_BALANCE: "user-added-balance",
    NODE_INVALID_EMAIL: "invalid-email",
    NODE_QUOTE_REQUEST_PROJECT_TASK_CREATED: "quote-request-project-task-created",
    NODE_QUOTE_PRE_AUTH_CREATED: "quote-pre-auth-created",
    NODE_GET_QUOTE_REQUEST_PROJECT_TASKS: "get-quote-request-project-tasks",
    NODE_BLOG_POST_PUBLISHED_UPDATED: "blog-post-published-updated",
    NODE_BLOG_POST_PUBLISH: "blog-post-publish",
    NODE_BLOG_POST_PUBLISHED: "blog-post-published",
    NODE_BLOG_POST_DELETED: "blog-post-deleted",
    NODE_QUOTE_REQUEST_PROJECT_TASK_USER_EVENT_CREATED: "qrpt-user-event-created",
    NODE_QUOTE_REQUEST_PROJECT_TASK_USER_EVENT_RESTORED: "qrpt-user-event-restored",
    NODE_QUOTE_REQUEST_PROJECT_TASK_USER_EVENT_UPLOAD_RESTORED: "qrpt-user-event-upload-restored",
    NODE_QUOTE_REQUEST_PROJECT_TASK_DELETED: "qrpt-deleted",
    NODE_QUOTE_REQUEST_PROJECT_TASK_CANCELED: "qrpt-canceled",
    NODE_QUOTE_REQUEST_PROJECT_TASK_USER_EVENT_UPLOAD_CREATED: "qrpt-user-event-upload-created",
    NODE_QUOTE_REQUEST_PROJECT_TASK_PREPAID: "qrpt-prepaid",
    NODE_QUOTE_REQUEST_PROJECT_TASK_STATUS_REOPENED: "qrpt-status-reopened",
    NODE_QUEUE_QUOTE_REQUEST_PROJECT_MEILI_INDEX: "qrp-meili-index",
    NODE_USER_EVENT_CREATED: "user-event-created",
    NODE_USER_EVENT_UPDATED: "user-event-updated",
    NODE_QUOTE_UPDATED: "quote-updated",
    NODE_QUOTE_CREATED: "quote-created",
    NODE_QUOTE_REQUEST_PROJECT_TASK_ACTIVE_UPDATED: "qrpt-active-updated",
    NODE_USER_UPDATED: "user-updated",
    NODE_USER_ORDER_BID_CREATED: "user-order-bid-created",
    NODE_USER_ORDER_BID_UPDATED: "user-order-bid-updated",
    NODE_NEW_USER_ORDER_BID: "new-user-order-bid",
    NODE_GET_USER_ORDER_BIDS: "get-user-order-bids",
    NODE_USER_ORDER_BID_ACCEPTED: "user-order-bid-accepted",
    NODE_UPDATE_USER_ORDER_BID: "update-user-order-bid",
    NODE_GET_NODE_FLOW_INSTANCES: "get-node-flow-instances",
    NODE_GET_LOG: "get-log",
    NODE_NEW_USER_EXISTS: "new-user-exists",
    NODE_ORDER_QBO_SYNC: "order-qbo-sync",
    NODE_USER_QBO_SYNC: "user-qbo-sync",
    NODE_ORDER_PAYMENT_QBO_SYNC: "order-payment-qbo-sync",
    NODE_FACTORY_BILL_QBO_SYNC: "factory-bill-qbo-sync",
    NODE_QBO_SYNC_FAILURE: "order-qbo-sync-failure",
    NODE_GET_ORDER_PAYMENTS: "get-order-payments",
    NODE_GET_PROOFS: "get-proofs",
    NODE_ORDER_SHIPPING_OPTIONS_MEILI_INDEX: "order-shipping-options-meili-index",
    NODE_ORDER_SHIPPING_OPTIONS_MEILI_INDEX_DELETE: "order-shipping-options-meili-index-delete",
    NODE_CHAT_GPT: "chatgpt",
    NODE_HELPSCOUT_MESSAGE_RECEIVED: "helpscout-message-received",
} as const;
export type NodeName = typeof NodeName[keyof typeof NodeName];
export declare interface NodeContext {
    payloads: { [key: number]: unknown};
    ids?: NodeContextIDs;
    data: { [key: string]: unknown};
}
export declare interface NodeContextIDs {
    nodeFlowID?: string;
    networkID?: string;
    companyID?: string;
    userID?: string;
    orderID?: string;
    loginCodeID?: string;
    cartID?: string;
    cartItemID?: string;
    quoteID?: string;
    stockItemID?: string;
    uploadID?: number;
    shippingOptionID?: string;
    paymentOptionID?: string;
    quoteRequestID?: string;
    quoteRequestProjectID?: string;
    quoteRequestProjectTaskID?: string;
    forgotPasswordID?: number;
    customerEmailID?: string;
    countryID?: CountryID;
    stateID?: StateID;
    salesTeamID?: string;
    pageRequestID?: string;
    quoteSentID?: string;
    quoteSentInstanceID?: string;
    imageID?: string;
    orderEventID?: string;
    flagID?: FlagID;
    userTaxExemptionID?: string;
    orderShippingOptionID?: string;
    factoryID?: string;
    carrierID?: CarrierID;
    promotionalCodeID?: string;
    orderPaymentID?: string;
    contactID?: string;
    orderShippingOptionShipmentID?: string;
    shipmentID?: string;
    quotePreAuthID?: string;
    blogPostID?: string;
    userEventID?: string;
    userEventUploadID?: string;
    userOrderBidID?: string;
    createdByUserID?: string;
}
export declare type Nodes = Node[];

export declare interface Node {
    nodeID: number;
    name: NodeName;
    data: { [key: string]: unknown};
    outputs: NodeOutput[];
    title: string;
    description: string;
    payloads?: string;
    x: number;
    y: number;
}
export declare interface NodeOutput {
    output: number;
    nodeID: number;
    input: number;
}
export declare interface NodeInput {
    output: number;
    nodeID: number;
    input: number;
}

// go/v2/notifications.go
export declare interface Notification {
    notificationUUID?: string;
    id?: string;
    createdByUserID?: string;
    userID?: string;
    title?: string;
    description?: string;
    link?: string;
    icon?: string;
    shown?: boolean;
    read?: boolean;
    linkDescriptionSHA256?: string;
    toUserIDLinkDescriptionSHA3224?: string;
    toUserIDLinkDescriptionMurmur332?: number;
    toUserIDDescriptionMurmur332?: number;
    created?: string;
}

// go/v2/orderchildlineitems.go
export declare interface OrderChildLineItem {
    id?: string;
    orderLineItemID?: string;
    childLineItemID?: ChildLineItemID;
    child?: string;
    childLineItemOptionID?: ChildLineItemOptionID;
    option?: string;
    autoQuantity?: boolean;
    linkedQuantity?: boolean;
    quantity?: number;
    price?: string;
    description?: string;
    sortOrder?: number;
    factoryCost?: string;
    factoryID?: string;
    cachedOrderID?: string;
    cachedTotal?: string;
    cachedFactoryCost?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orderLineItem?: OrderLineItem;
    order?: Order;
    childLineItem?: ChildLineItem;
    childLineItemOption?: ChildLineItemOption;
}

// go/v2/ordereventimages.go
export declare interface OrderEventImage {
    id?: string;
    orderEventID?: string;
    imageID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    image?: Image;
    createdBy?: User;
}

// go/v2/orderevents.go
export declare interface OrderEvent {
    id?: string;
    orderID?: string;
    content?: string;
    contentType?: OrderEventContentType;
    pinned?: boolean;
    automated?: boolean;
    approved?: boolean;
    approvedUserID?: string;
    forSales?: boolean;
    factoryComment?: boolean;
    orderEventType?: OrderEventType;
    addressed?: boolean;
    read?: boolean;
    orderLineItemID?: string;
    stageID?: string;
    to?: OrderEventTo;
    toFactoryID?: string;
    user?: string;
    systemBiddingNotice?: boolean;
    textContent?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    order?: Order;
    orderLineItem?: OrderLineItem;
    toFactory?: Factory;
    orderEventImages?: OrderEventImage[];
    orderEventUploads?: OrderEventUpload[];
    createdBy?: User;
}
export const OrderEventContentType = {
    ORDER_EVENT_CONTENT_TYPE_TEXT: 0,
    ORDER_EVENT_CONTENT_TYPE_HTML: 1,
} as const;
export type OrderEventContentType = typeof OrderEventContentType[keyof typeof OrderEventContentType];
export const OrderEventType = {
    ORDER_EVENT_TYPE_MISC: 0,
    ORDER_EVENT_TYPE_SALES: 1,
    ORDER_EVENT_TYPE_FACTORY: 2,
    ORDER_EVENT_TYPE_FRONT_OFFICE: 3,
    ORDER_EVENT_TYPE_FLAG: 4,
    ORDER_EVENT_TYPE_UPDATE: 5,
} as const;
export type OrderEventType = typeof OrderEventType[keyof typeof OrderEventType];
export const OrderEventTo = {
    ORDER_EVENT_TO_FACTORY: "factory",
    ORDER_EVENT_TO_SALES: "sales",
    ORDER_EVENT_TO_ACCOUNTING: "accounting",
    ORDER_EVENT_TO_MARKETING: "marketing",
} as const;
export type OrderEventTo = typeof OrderEventTo[keyof typeof OrderEventTo];
export declare interface OrderEventPermissions {
    write?: boolean;
    writeOthers?: boolean;
    writeAddressed?: boolean;
    writeRead?: boolean;
    writeApproved?: boolean;
}

// go/v2/ordereventuploads.go
export declare interface OrderEventUpload {
    id?: string;
    orderEventID?: string;
    uploadID?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    upload?: Upload;
    createdBy?: User;
}

// go/v2/orderlineitemblanks.go
export declare interface OrderLineItemBlank {
    id?: string;
    orderLineItemID?: string;
    blankID?: string;
    blankVersion?: number;
    quantity?: number;
    createdByUserID?: string;
    created?: string;
    validUntil?: string;
    blank?: Blank;
}

// go/v2/orderlineitems.go
export declare interface OrderLineItem {
    id?: string;
    orderID?: string;
    lineItemID?: LineItemID;
    lineItem?: string;
    lineItemTypeID?: LineItemTypeID;
    type?: string;
    lineItemTypeSizeID?: string;
    size?: string;
    quantity?: number;
    price?: string;
    description?: string;
    salesTeamID?: string;
    factoryID?: string;
    shippingAccountID?: string;
    orderProofID?: string;
    networkSKUID?: string;
    quoteLineItemID?: string;
    parentOrderLineItemID?: string;
    stockItemID?: string;
    sortOrder?: number;
    factoryCost?: string;
    artistReward?: string;
    cachedTotal?: string;
    cachedFactoryCost?: string;
    cachedCompanyID?: string;
    cachedPendingUpdated?: string;
    cachedTax?: boolean;
    cachedStats?: boolean;
    orderLineItemIDSHA3224?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    customerEditable?: boolean;
    invalidCustomQuantity?: boolean;
    order?: Order;
    lineItemModel?: LineItem;
    lineItemType?: LineItemType;
    lineItemTypeSize?: LineItemTypeSize;
    quoteLineItem?: QuoteLineItem;
    orderProof?: OrderProof;
    stockItem?: StockItem;
    orderChildLineItems?: OrderChildLineItem[];
    orderLineItemStages?: OrderLineItemStage[];
}

// go/v2/orderlineitemstages.go
export declare interface OrderLineItemStage {
    id?: string;
    orderLineItemID?: string;
    stageID?: string;
    start?: string;
    stop?: string;
    user?: string;
    notes?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orderLineItem?: OrderLineItem;
    stage?: Stage;
    createdBy?: User;
}

// go/v2/ordermanagingcompanypercentages.go
export declare interface OrderManagingCompanyPercentage {
    id?: number;
    orderID?: string;
    managingCompanyID?: string;
    rate?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/orderorders.go
export declare interface OrderOrder {
    orderID?: string;
    parentOrderID?: string;
}

// go/v2/orderpayments.go
export declare interface OrderPayment {
    id?: string;
    orderID?: string;
    paymentOptionID?: string;
    originalChargeCompanyID?: string;
    total?: string;
    checkNumber?: string;
    purchaseOrderNumber?: string;
    paid?: string;
    staxTransactionID?: string;
    payPalToken?: string;
    qboPaymentID?: string;
    qboSync?: boolean;
    qboDeposited?: boolean;
    createdByUserID?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    order?: Order;
    createdBy?: User;
    paymentOption?: PaymentOption;
    originalChargeRealm?: Realm;
    orderPayments?: OrderPayment[];
}

// go/v2/orderproofs.go
export declare interface OrderProof {
    id?: string;
    orderID?: string;
    proofID?: string;
    name?: string;
    createdBy?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    order?: Order;
    proof?: Proof;
    quoteProof?: QuoteProof;
    stockItemImage?: StockItemImage;
}

// go/v2/orders.go
export declare interface Order {
    id?: string;
    invoiceNumber?: number;
    companyID?: string;
    orderStatusID?: OrderStatusID;
    factoryID?: string;
    originalFactoryID?: string;
    shippingAccountID?: string;
    promotionalCodeID?: string;
    salesTeamID?: string;
    userID?: string;
    clientID?: string;
    pending?: boolean;
    active?: boolean;
    taxJarSynced?: string;
    taxJarInactive?: boolean;
    created?: string;
    date?: string;
    confirmedTime?: string;
    placedTime?: string;
    factoryShipDate?: string;
    customerShipDate?: string;
    factoryConfirmedShipDate?: string;
    eventDate?: string;
    name?: string;
    createdByUserID?: string;
    bidsNeeded?: boolean;
    key?: string;
    preorder?: boolean;
    unshippedSortOrder?: number;
    markedAsShipped?: boolean;
    lateOrderIgnored?: string;
    placeOrder?: number;
    factoryCostUpdatedUserID?: string;
    updatedByUserID?: string;
    salesUserID?: string;
    factoryCostUpdatedTime?: string;
    updated?: string;
    taxTransactionDate?: string;
    qboInvoiceID?: string;
    qboBillID?: string;
    qboFactoryCostSync?: boolean;
    qboFactoryCostSynced?: string;
    billTransfer?: number;
    billTransferred?: string;
    orderIDSHA3224?: string;
    remindCount?: number;
    noInvoice?: boolean;
    pendingUpdated?: string;
    total?: string;
    totalSansTax?: string;
    paid?: string;
    factoryCost?: string;
    shippingCost?: string;
    balance?: string;
    paidUpdated?: string;
    shipByForEventDate?: string;
    shipmentsCount?: number;
    unconfirmedOrPreorder?: boolean;
    dueDate?: string;
    factory?: Factory;
    shippingAccount?: ShippingAccount;
    salesTeam?: SalesTeam;
    realm?: Realm;
    user?: User;
    quoteOrders?: QuoteOrder[];
    orderProofs?: OrderProof[];
    orderLineItems?: OrderLineItem[];
    orderShippingOptions?: OrderShippingOption[];
    userTaxExemptionOrders?: UserTaxExemptionOrder[];
    orderPayments?: OrderPayment[];
    quoteRequestProjectTasks?: QuoteRequestProjectTask[];
    flagFlags?: FlagFlag[];
    orderEvents?: OrderEvent[];
    orderUploads?: OrderUpload[];
    purchaseOrderFiles?: PurchaseOrderFile[];
    orderDetails?: OrderDetails;
    rawOrderDetails?: OrderDetail[];
    userOrderBids?: UserOrderBid[];
}
export declare interface OrderDetail {
    id?: string;
    orderID?: string;
    name?: string;
    value?: unknown;
    active?: boolean;
    created?: string;
    updated?: string;
}
export declare interface OrderDetails {
    factoryPreference: string[];
    biddingWaitUntil?: string;
}

// go/v2/ordershippingoptions.go
export declare interface OrderShippingOption {
    id?: string;
    orderID?: string;
    shippingOptionID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    cachedCost?: string;
    shipToBuilding?: boolean;
    order?: Order;
    shippingOption?: ShippingOption;
    orderShippingOptionShipments?: OrderShippingOptionShipment[];
}

// go/v2/ordershippingoptionshipments.go
export declare interface OrderShippingOptionShipment {
    id?: string;
    orderShippingOptionID?: string;
    shipmentID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    cachedCost?: string;
    shipment?: Shipment;
    orderShippingOption?: OrderShippingOption;
}

// go/v2/orderstatuses.go
export declare interface OrderStatus {
    id?: OrderStatusID;
    name?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
export const OrderStatusID = {
    ORDER_STATUSES_CONFIRMED: 4,
    ORDER_STATUSES_INVOICE_ONLY: 1,
    ORDER_STATUSES_ORDER: 2,
    ORDER_STATUSES_UNCONFIRMED: 3,
} as const;
export type OrderStatusID = typeof OrderStatusID[keyof typeof OrderStatusID];

// go/v2/orderuploads.go
export declare interface OrderUpload {
    id?: string;
    orderID?: string;
    uploadID?: number;
    tags?: string[];
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    order?: Order;
    upload?: Upload;
    createdBy?: User;
}

// go/v2/pagecompanies.go
export declare interface PageCompany {
    PageCompanyID: number;
    PageID: string;
    CompanyID: string;
    active?: boolean;
    created?: string;
    updated?: string;
    page?: Page;
    company?: Realm;
}

// go/v2/pagerequests.go
export declare interface PageRequest {
    id?: string;
    companyID?: string;
    ipAddress?: string;
    userID?: string;
    sentEmailID?: string;
    blogID?: string;
    host?: string;
    requestURI?: string;
    referer?: string;
    os?: string;
    osVersion?: string;
    browser?: string;
    browserVersion?: string;
    userAgent?: string;
    mobile?: boolean;
    width?: number;
    height?: number;
    unique?: boolean;
    countryID?: CountryID;
    stateID?: StateID;
    clientID?: string;
    dateTimeOnline?: string;
    linkID?: string;
    followUpAltID?: number;
    ingress?: boolean;
    possibleUserID?: string;
    path?: string;
    pathMurmur?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    link?: Link;
    followUp?: FollowUp;
}

// go/v2/pages.go
export declare interface Page {
    id?: string;
    networkID?: string;
    modifiedByUserID?: string;
    categories?: string[];
    input?: string;
    output?: string;
    publishedTime?: string;
    published?: boolean;
    body?: string;
    siteMap?: boolean;
    description?: string;
    hash?: string;
    sortOrder?: number;
    twitterTitle?: string;
    twitterDescription?: string;
    facebookTitle?: string;
    facebookDescription?: string;
    redirect?: string;
    resources?: {
        js?: string[];
        css?: string[];
    };
    publishable?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    pageCompanies?: PageCompany[];
    network?: Network;
    createdBy?: User;
    updatedBy?: User;
}

// go/v2/paymentoptions.go
export declare interface PaymentOption {
    id?: string;
    paymentOptionTypeID?: PaymentOptionTypeID;
    companyID?: string;
    userID?: string;
    name?: string;
    fullName?: string;
    company?: string;
    email?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateID?: StateID;
    zip?: string;
    countryID?: CountryID;
    phone?: string;
    creditCardFirst6?: number;
    creditCardLast4?: number;
    creditCardExpirationDate?: string;
    fattmerchantOmniPaymentMethodID?: string;
    key?: string;
    declined?: boolean;
    accountType?: PaymentOptionAccountType;
    bankType?: PaymentOptionBankType;
    sortOrder?: number;
    created?: string;
    active?: boolean;
    paymentOptionType?: PaymentOptionType;
    realm?: Realm;
    user?: User;
    country?: Country;
    state?: State;
    orderPayments?: OrderPayment[];
}
export const PaymentOptionAccountType = {
    PAYMENT_OPTION_ACCOUNT_TYPE_CHECKING: "checking",
    PAYMENT_OPTION_ACCOUNT_TYPE_SAVINGS: "savings",
} as const;
export type PaymentOptionAccountType = typeof PaymentOptionAccountType[keyof typeof PaymentOptionAccountType];
export const PaymentOptionBankType = {
    PAYMENT_OPTION_BANK_TYPE_PERSONAL: "personal",
    PAYMENT_OPTION_BANK_TYPE_BUSINESS: "business",
} as const;
export type PaymentOptionBankType = typeof PaymentOptionBankType[keyof typeof PaymentOptionBankType];

// go/v2/paymentoptiontypes.go
export declare interface PaymentOptionType {
    id?: PaymentOptionTypeID;
    name?: string;
    termName?: string;
}
export const PaymentOptionTypeID = {
    PAYMENT_OPTION_TYPE_NONE: 0,
    PAYMENT_OPTION_TYPE_CREDIT: 1,
    PAYMENT_OPTION_TYPE_CHECK: 2,
    PAYMENT_OPTION_TYPE_CASH: 3,
    PAYMENT_OPTION_TYPE_WIRE: 4,
    PAYMENT_OPTION_TYPE_PO: 5,
    PAYMENT_OPTION_TYPE_PAY_PAL: 6,
    PAYMENT_OPTION_TYPE_BALANCE: 7,
    PAYMENT_OPTION_TYPE_BANK: 8,
} as const;
export type PaymentOptionTypeID = typeof PaymentOptionTypeID[keyof typeof PaymentOptionTypeID];

// go/v2/promotionalcodes.go
export declare interface PromotionalCode {
    id?: string;
    networkID?: string;
    companyID?: string;
    linkID?: string;
    name?: string;
    description?: string;
    code?: string;
    formula?: string;
    ownerUserID?: string;
    ownerFormula?: string;
    expires?: string;
    minimumSubtotal?: string;
    max?: string;
    buy?: number;
    get?: number;
    js?: string;
    codeMurmur?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    network?: Network;
    company?: Realm;
    link?: Link;
    createdBy?: User;
}

// go/v2/prooflayouts.go
export declare interface ProofLayout {
    id?: string;
    originalProofLayoutID?: string;
    companyID?: string;
    uploads?: ProofLayoutUploads;
    layout?: unknown;
    active?: boolean;
    created?: string;
    updated?: string;
}
export declare interface ProofLayoutUploads {
    twoInchGridProof?: number;
    threeInchGridProof?: number;
    fiveInchGridProof?: number;
    default?: number;
}

// go/v2/proofs.go
export declare interface Proof {
    id?: string;
    imageID?: string;
    uploadID?: number;
    proofLayoutID?: string;
    hash?: string;
    name?: string;
    path?: string;
    file?: string;
    size?: number;
    emailSize?: number;
    live?: boolean;
    created?: string;
    main?: string;
    thumbnail?: string;
    latestOrderFrontMold?: Order;
    latestOrderBackMold?: Order;
    image?: Image;
    upload?: Upload;
    quoteProofs?: QuoteProof[];
    orderProofs?: OrderProof[];
}

// go/v2/purchaseorderfiles.go
export declare interface PurchaseOrderFile {
    id?: string;
    orderID?: string;
    imageID?: string;
    uploadID?: number;
    name?: string;
    path?: string;
    extension?: string;
    size?: number;
    active?: boolean;
    created?: string;
    image?: Image;
    upload?: Upload;
}

// go/v2/qrptstatusupdates.go
export declare interface QRPTStatusUpdate {
    id?: string;
    quoteRequestProjectTaskStatusID?: QuoteRequestProjectTaskStatusID;
    quoteRequestProjectTaskID?: string;
    userID?: string;
    created?: string;
}

// go/v2/quotechildlineitems.go
export declare interface QuoteChildLineItem {
    id?: string;
    quoteLineItemID?: string;
    childLineItemID?: string;
    child?: string;
    childLineItemOptionID?: string;
    option?: string;
    autoQuantity?: boolean;
    linkedQuantity?: boolean;
    quantity?: number;
    price?: string;
    description?: string;
    sortOrder?: number;
    childLineItem?: ChildLineItem;
    childLineItemOption?: ChildLineItemOption;
}

// go/v2/quotelineitems.go
export declare interface QuoteLineItem {
    id?: string;
    quoteID?: string;
    lineItemID?: LineItemID;
    lineItem?: string;
    lineItemTypeID?: LineItemTypeID;
    type?: string;
    lineItemTypeSizeID?: string;
    size?: string;
    quantity?: number;
    price?: string;
    description?: string;
    sortOrder?: number;
    quoteProofID?: string;
    networkSKUID?: string;
    customerEditable?: boolean;
    invalidCustomQuantity?: boolean;
    cachedQuoteRequestProjectID?: string;
    quoteProof?: QuoteProof;
    lineItemModel?: LineItem;
    lineItemType?: LineItemType;
    lineItemTypeSize?: LineItemTypeSize;
    quoteChildLineItems?: QuoteChildLineItem[];
}

// go/v2/quotemessageimage.go
export declare interface QuoteMessageImage {
    id?: string;
    quoteMessageImageID?: string;
    imageID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    quoteMessage?: QuoteMessage;
    image?: Image;
}

// go/v2/quotemessages.go
export declare interface QuoteMessage {
    id?: string;
    companyID?: string;
    name?: string;
    subject?: string;
    message?: string;
    contentType?: string;
    default?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    realm?: Realm;
    quoteMessageImages?: QuoteMessageImage[];
}

// go/v2/quoteorders.go
export declare interface QuoteOrder {
    quoteID?: string;
    orderID?: string;
    companyID?: string;
    created?: string;
    quote?: Quote;
    order?: Order;
}

// go/v2/quotepreauths.go
export declare interface QuotePreAuth {
    id?: string;
    companyID?: string;
    quoteID?: string;
    userID?: string;
    amount?: string;
    staxtransactionID?: string;
    paypaltoken?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    quote?: Quote;
    realm?: Realm;
}

// go/v2/quoteproofs.go
export declare interface QuoteProof {
    id?: string;
    quoteID?: string;
    proofID?: string;
    name?: string;
    number?: string;
    created?: string;
    userEvents?: UserEvent[];
    proof?: Proof;
}

// go/v2/quoterequestimages.go
export declare interface QuoteRequestImage {
    id?: string;
    quoteRequestID?: string;
    imageID?: string;
    quoteRequest?: QuoteRequest;
    image?: Image;
}

// go/v2/quoterequestprojects.go
export declare interface QuoteRequestProject {
    id?: string;
    quoteRequestID?: string;
    quoteID?: string;
    companyID?: string;
    userID?: string;
    name?: string;
    leadRating?: number;
    predictedLeadRating?: number;
    saveID?: string;
    quoteRequestAdded?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    read?: boolean;
    addressed?: boolean;
    realm?: Realm;
    user?: User;
    quoteRequest?: QuoteRequest;
    quote?: Quote;
    quoteSent?: QuoteSent;
    quoteRequestProjects?: QuoteRequestProject[];
    quoteRequests?: QuoteRequest[];
    flagFlags?: FlagFlag[];
}

// go/v2/quoterequestprojecttaskpriorities.go
export declare interface QuoteRequestProjectTaskPriority {
    id?: QuoteRequestProjectTaskPriorityID;
    name?: string;
    default?: boolean;
    color?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}
export const QuoteRequestProjectTaskPriorityID = {
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_BUMP: 1,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_LOW: 2,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_MEDIUM: 3,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_RTO: 4,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_REPEAT_CUSTOMER: 5,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_RUSH: 6,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_PREPAID: 7,
} as const;
export type QuoteRequestProjectTaskPriorityID = typeof QuoteRequestProjectTaskPriorityID[keyof typeof QuoteRequestProjectTaskPriorityID];

// go/v2/quoterequestprojecttaskproofs.go
export declare interface QuoteRequestProjectTaskProof {
    id?: string;
    quoteRequestProjectTaskID?: string;
    proofID?: string;
}

// go/v2/quoterequestprojecttasks.go
export declare interface QuoteRequestProjectTask {
    id?: string;
    companyID?: string;
    userID?: string;
    quoteRequestID?: string;
    orderID?: string;
    quoteRequestProjectTaskTypeID?: QuoteRequestProjectTaskTypeID;
    quoteRequestProjectTaskStatusID?: QuoteRequestProjectTaskStatusID;
    quoteRequestProjectTaskPriorityID?: QuoteRequestProjectTaskPriorityID;
    key?: string;
    difficulty?: string;
    timeBudget?: number;
    numberOfDesigns?: number;
    salesUserID?: string;
    assignedUserID?: string;
    lineItemID?: string;
    lineItemTypeID?: string;
    quoteProofID?: string;
    customerRequest?: boolean;
    clearinghouse?: boolean;
    phoned?: boolean;
    screenRecord?: boolean;
    doneTime?: string;
    hiddenFromArtists?: boolean;
    sortOrder?: number;
    changelog?: ModelChangelogEntry[];
    active?: boolean;
    created?: string;
    realm?: Realm;
    user?: User;
    userEvent?: UserEvent[];
    salesUser?: User;
    quoteProof?: QuoteProof;
    quoteRequest?: QuoteRequest;
    quoteRequestProjectTaskType?: QuoteRequestProjectTaskType;
    quoteRequestProjectTaskStatus?: QuoteRequestProjectTaskStatus;
    quoteRequestProjectTaskPriority?: QuoteRequestProjectTaskPriority;
    lineItem?: LineItem;
    lineItemType?: LineItemType;
}

// go/v2/quoterequestprojecttaskstatuses.go
export declare interface QuoteRequestProjectTaskStatus {
    id?: QuoteRequestProjectTaskStatusID;
    name?: string;
    default?: boolean;
    color?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}
export const QuoteRequestProjectTaskStatusID = {
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_HOLD: 1,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_IN_PROGRESS: 2,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_ADJUSTMENT_NEEDED: 3,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_FIX_NEEDED: 4,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_ART_DONE: 5,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_SENT: 6,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_BUMP: 7,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_QUALIFIED: 8,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_UNQUALIFIED: 9,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_VECTOR_DONE: 10,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_PAUSED: 11,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_REVIEW_NEEDED: 12,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_CUSTOMER_CANCELED: 13,
} as const;
export type QuoteRequestProjectTaskStatusID = typeof QuoteRequestProjectTaskStatusID[keyof typeof QuoteRequestProjectTaskStatusID];

// go/v2/quoterequestprojecttasktypes.go
export declare interface QuoteRequestProjectTaskType {
    id?: QuoteRequestProjectTaskTypeID;
    name?: string;
    default?: boolean;
    color?: string;
    sortOrder?: number;
    artistRewardValue?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
export const QuoteRequestProjectTaskTypeID = {
    QUOTE_REQUEST_PROJECT_TASK_TYPES_REVISION: 1,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_NEW: 2,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_SMALL_REVISION: 3,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_LARGE_REVISION: 4,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_3_D_REVIEW: 5,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_CONTENT_FIX: 6,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_SPELLING_FIX: 7,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_ADJUSTMENT: 8,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_VECTOR_REVIEW: 9,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_PROOF_NEEDED: 10,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_FACTORY_FILE: 11,
} as const;
export type QuoteRequestProjectTaskTypeID = typeof QuoteRequestProjectTaskTypeID[keyof typeof QuoteRequestProjectTaskTypeID];

// go/v2/quoterequests.go
export declare interface QuoteRequest {
    id?: string;
    quoteRequestProjectID?: string;
    companyID?: string;
    userID?: string;
    company?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateID?: StateID;
    zip?: string;
    countryID?: CountryID;
    lineItemID?: LineItemID;
    quantity?: number;
    dateNeeded?: string;
    notes?: string;
    notesObj?: { [key: string]: unknown};
    remoteAddress?: string;
    sales?: boolean;
    classicForm?: boolean;
    clientID?: string;
    iap?: boolean;
    selfCreated?: boolean;
    folder?: string;
    downloaded?: boolean;
    linkID?: string;
    pageRequestID?: string;
    budget?: string;
    form?: string;
    createdByUserID?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    unread?: boolean;
    notAddressed?: boolean;
    firstIngressPageRequestID?: string;
    lastIngressPageRequestID?: string;
    realm?: Realm;
    user?: User;
    quoteRequestProject?: QuoteRequestProject;
    uploads?: Upload[];
    quoteRequestImages?: QuoteRequestImage[];
    quotes?: Quote[];
    quoteRequestProjectTasks?: QuoteRequestProjectTask[];
    quoteRequestUploads?: QuoteRequestUpload[];
    link?: Link;
    country?: Country;
    state?: State;
}
export declare interface EasyQuoteRequestChild {
    Child: string;
    Option: string;
    Quantity: number;
}
export declare interface EasyQuoteRequestExtra {
    Name: string;
    Value: string;
}

// go/v2/quoterequestuploads.go
export declare interface QuoteRequestUpload {
    id?: string;
    quoteRequestID?: string;
    uploadID?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    quoteRequest?: QuoteRequest;
    upload?: Upload;
}

// go/v2/quotes.go
export declare interface Quote {
    id?: string;
    quoteRequestID?: string;
    number?: number;
    open?: boolean;
    send?: boolean;
    viewed?: boolean;
    addressed?: boolean;
    shippingOptionID?: string;
    paymentOptionID?: string;
    serial?: string;
    hidden?: boolean;
    classicForm?: boolean;
    blocked?: boolean;
    eventDate?: string;
    userID?: string;
    key?: string;
    createdByUserID?: string;
    created?: string;
    active?: boolean;
    companyID?: string;
    sent?: boolean;
    cachedTotal?: string;
    cachedQuoteRequestProjectID?: string;
    quoteRequest?: QuoteRequest;
    user?: User;
    createdBy?: User;
    realm?: Realm;
    quoteProofs?: QuoteProof[];
    quoteLineItems?: QuoteLineItem[];
    quoteSents?: QuoteSent[];
    quoteOrders?: QuoteOrder[];
    shippingOption?: ShippingOption;
    paymentOption?: PaymentOption;
    quotePreAuths?: QuotePreAuth[];
}

// go/v2/quotesents.go
export declare interface QuoteSent {
    id?: string;
    quoteID?: string;
    sentEmailID?: string;
    createdByUserID?: string;
    quoteSentInstanceID?: string;
    followUpID?: string;
    name?: string;
    emails?: string;
    ccs?: string;
    phones?: string[];
    subject?: string;
    content?: string;
    contentType?: string;
    invoice?: boolean;
    key?: string;
    sentWithProofs?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    userID?: string;
    latest?: boolean;
    companyID?: string;
    highestTotalQuoteID?: string;
    highestTotal?: string;
    lowestTotalQuoteID?: string;
    lowestTotal?: string;
    contacted?: string;
    quote?: Quote;
    user?: User;
    realm?: Realm;
}

// go/v2/realms.go
export declare interface Realm {
    id?: string;
    number?: number;
    networkID?: string;
    salesTeamID?: string;
    shippingAccountID?: string;
    defaultSalesUserID?: string;
    name?: string;
    description?: string;
    email?: string;
    phone?: string;
    url?: string;
    lineItemID?: string;
    cloudFront?: string;
    taxJarAPIKey?: string;
    helpScoutMailboxID?: number;
    helpScoutMailboxSlug?: string;
    fattmerchantOmniAPIKey?: string;
    host?: string;
    htmlEmails?: boolean;
    quoteLink?: string;
    orderLink?: string;
    fattmerchantOmniWebPaymentsToken?: string;
    network?: Network;
    shippingAccount?: ShippingAccount;
    lineItem?: LineItem;
    companyDetails?: CompanyDetails;
    defaultSalesUser?: User;
}
export declare interface CompanyDetail {
    id?: string;
    companyID?: string;
    name?: string;
    value?: string;
    json?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
}
export declare interface CompanyDetails {
    snsNumber?: string;
    v3CartCheckoutURL: string;
    v3CartCartURL: string;
    v3QuoteCheckoutURL?: string;
    v3QuoteCartURL?: string;
    v3QuoteViewURL?: string;
    v3QuoteInstanceViewURL?: string;
    v3OrderCheckoutURL?: string;
    v3OrderCartURL?: string;
    v3PasswordResetURL?: string;
    v3MakePaymentURL?: string;
    v3OrderTrackURL?: string;
    v3QRPTURL?: string;
    defaultSalesTeamIDs?: string[];
    weightedDefaultSalesTeamIDs?: WeightedSalesTeam[];
    googleSignInClientID?: string;
    cartItemGlobalPricingContextJS?: string;
    payPalClientID?: string;
    payPalSecret?: string;
    podiumLocationUID?: string;
    smsNumber?: string;
    podiumAlternateReviewLink?: string;
    reCaptchaV2SiteKey?: string;
    reCaptchaV2SecretKey?: string;
    reCaptchaV3SiteKey?: string;
    reCaptchaV3SecretKey?: string;
    freeShippingMin?: string;
    disableHTMLEmails?: boolean;
    quoteRequestEmailVersion?: number;
    repo?: string;
    repoDir?: string;
    githubDeployWorkflowURL?: string;
    blogDir?: string;
    blogImgWidth?: number;
    hugoBaseURL?: string;
    ein?: string;
    productTypeQuizPrompt?: string;
    color?: string;
    moldExpiryInDays?: number;
}
export declare interface WeightedSalesTeam {
    salesTeamID: string;
    weight: number;
}
export const CompanyID = {
    COMPANIES_ALL_ABOUT_LANYARDS: "FUGW1EhjGAI",
    COMPANIES_ALL_ABOUT_PATCHES: "FUGW1ExnO0I",
    COMPANIES_ALL_ABOUT_PINS: "FUGW1FBv_FI",
    COMPANIES_CHALLENGE_COIN_NATION: "FUGW1CgJrPI",
    COMPANIES_CHALLENGE_COINS_CITY: "FUGW1CwXsGI",
    COMPANIES_CHALLENGE_COINS_EXPRESS: "FUGW1HS1YQI",
    COMPANIES_CHALLENGE_COINS_PLUS: "FUGW1BfkosI",
    COMPANIES_COIN_DEPOT: "FUGW1Afct_I",
    COMPANIES_CUSTOM_LANYARDS_PLUS: "FUGW1BvvLaI",
    COMPANIES_CUSTOM_MEDALS_PLUS: "FUGW1CQIILI",
    COMPANIES_EMBROIDERED_PATCHES_PLUS: "FUGW1CAAssI",
    COMPANIES_GRANT: "FUGW1ALgoQI",
    COMPANIES_LANYARD_DEPOT: "FUGW1ALlC0I",
    COMPANIES_LANYARDS_EXPRESS: "FUGW1HzY03I",
    COMPANIES_LAPEL_PIN_PRODUCTIONS: "FUGW1Dg111I",
    COMPANIES_LAPEL_PINS_CITY: "FUGW1DAdiBI",
    COMPANIES_LAPEL_PINS_EXPRESS: "FUGW1HCqCEI",
    COMPANIES_LAPEL_PINS_ONLINE: "FUGW1DxB1kI",
    COMPANIES_LAPEL_PINS_PLUS: "FUGW1BPaCtI",
    COMPANIES_LAPEL_PINS_USA: "FUGW1DQpvnI",
    COMPANIES_PATCH_DEPOT: "FUGW1A_VHWI",
    COMPANIES_PATCHES_EXPRESS: "FUGW1HjE_MI",
    COMPANIES_PIN_DEPOT: "FUGW1AvY4hI",
    COMPANIES_PIN_PROMOTIONS: "FUGW1EBBlMI",
    COMPANIES_SIGNATURE_COINS: "FUGW1FiCBPI",
    COMPANIES_SIGNATURE_LANYARDS: "FUGW1FyG6nI",
    COMPANIES_SIGNATURE_PATCHES: "FUGW1GCK-OI",
    COMPANIES_SIGNATURE_PINS: "FUGW1GyeryI",
    COMPANIES_SIGNATURE_TRADING_PINS: "FUGW1GSPrGI",
    COMPANIES_STERLING_MARKETING_GROUP: "FUGW1HCoItI",
    COMPANIES_THE_LAPEL_PIN_BUTTON_CO: "FUGW1GiYoLI",
    COMPANIES_TNG_CONSOLIDATED: "FUGW1HCmB2I",
    COMPANIES_TRADING_PINS: "FUGW1ITiiyI",
    COMPANIES_USDOD_COINS: "FUGW1IDiq_I",
} as const;
export type CompanyID = typeof CompanyID[keyof typeof CompanyID];

// go/v2/receivedemails.go
export declare interface ReceivedEmail {
    id?: string;
    companyID?: string;
    subject?: string;
    received?: string;
    helpScoutConversationID?: number;
    active?: boolean;
    created?: string;
    receivedEmailTos?: ReceivedEmailTo[];
}

// go/v2/receivedemailtos.go
export declare interface ReceivedEmailTo {
    id?: string;
    receivedEmailID?: string;
    name?: string;
    email?: string;
    active?: boolean;
    created?: string;
}

// go/v2/rekognition.go
export declare interface RekognitionLabel {
    label?: string;
    moderation?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/salesteamnetworks.go
export declare interface SalesTeamNetwork {
    id?: string;
    networkID?: string;
    salesTeamID?: string;
    percentage?: string;
    created?: string;
    network?: Network;
    salesTeam?: SalesTeam;
}

// go/v2/salesteams.go
export declare interface SalesTeam {
    id?: string;
    name?: string;
    leaderboard?: boolean;
    primaryHelpScoutMailboxID?: number;
    helpScoutMailboxIDs?: number[];
    helpScoutTeamID?: number;
    originalSalesTeamID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    salesTeamNetworks?: SalesTeamNetwork[];
    salesTeamUser?: SalesTeamUser[];
}

// go/v2/salesteamusers.go
export declare interface SalesTeamUser {
    id?: string;
    userID?: string;
    salesTeamID?: string;
    percentage?: string;
    created?: string;
    originalSalesTeamID?: string;
    user?: User;
    salesTeam?: SalesTeam;
}

// go/v2/sentemailbccs.go
export declare interface SentEmailBCC {
    id?: string;
    sentEmailID?: string;
    email?: string;
    name?: string;
    sentEmail?: SentEmail;
}

// go/v2/sentemailbodies.go
export declare interface SentEmailBody {
    id?: string;
    sentEmailID?: string;
    body?: string;
    type?: string;
    sentEmail?: SentEmail;
}

// go/v2/sentemailccs.go
export declare interface SentEmailCC {
    id?: string;
    sentEmailID?: string;
    email?: string;
    name?: string;
    sentEmail?: SentEmail;
}

// go/v2/sentemailreplytos.go
export declare interface SentEmailReplyTo {
    id?: string;
    sentEmailID?: string;
    email?: string;
    name?: string;
    sentEmail?: SentEmail;
}

// go/v2/sentemails.go
export declare interface SentEmail {
    id?: string;
    sentEmailCategoryID?: string;
    companyID?: string;
    subject?: string;
    fromEmail?: string;
    fromName?: string;
    trackEmail?: boolean;
    error?: boolean;
    bccError?: boolean;
    created?: string;
    realm?: Realm;
    sentEmailBodies?: SentEmailBody[];
}

// go/v2/sentemailtos.go
export declare interface SentEmailTo {
    id?: string;
    sentEmailID?: string;
    email?: string;
    name?: string;
    sentEmail?: SentEmail;
}

// go/v2/shipments.go
export declare interface Shipment {
    id?: string;
    parentShipmentID?: string;
    carrierID?: CarrierID;
    trackingNumber?: string;
    carrierShipmentID?: string;
    shippingAccountID?: string;
    shipmentTypeID?: ShipmentTypeID;
    accountNumber?: string;
    cost?: string;
    insured?: boolean;
    shipFullName?: string;
    shipCompany?: string;
    shipAddressLine1?: string;
    shipAddressLine2?: string;
    shipCity?: string;
    shipStateID?: StateID;
    shipZip?: string;
    shipCountryID?: CountryID;
    shipPhone?: string;
    toFullName?: string;
    toCompany?: string;
    toAddressLine1?: string;
    toAddressLine2?: string;
    toCity?: string;
    toStateID?: StateID;
    toZip?: string;
    toCountryID?: CountryID;
    toPhone?: string;
    reference?: string;
    real?: boolean;
    system?: boolean;
    factory?: boolean;
    waybillBolNumber?: string;
    harmonizedCode?: string;
    declaredValue?: string;
    customsDescription?: string;
    weightLBS?: string;
    customsQuantity?: number;
    service?: string;
    apo?: boolean;
    failedToInsure?: boolean;
    createdByUserID?: string;
    created?: string;
    active?: boolean;
    documents?: ShipmentUploads;
    orderID?: string;
    shipped?: string;
    delivered?: string;
    returned?: string;
    exception?: string;
    shippingBillID?: string;
    shippingAccount?: ShippingAccount;
    carrier?: Carrier;
    label?: Upload;
    copyDocument?: Upload;
    order?: Order;
    fromAddress?: Address;
    toAddress?: Address;
    shipments?: Shipment[];
    createdBy?: User;
    shippingBill?: ShippingBill;
    shipmentType?: ShipmentType;
}
export declare interface ShipmentUploads {
    label?: number;
    copyDocument?: number;
    commercialInvoice?: number;
    waybillDoc?: number;
}

// go/v2/shipmenttypes.go
export declare interface ShipmentType {
    id?: ShipmentTypeID;
    name?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
export const ShipmentTypeID = {
    SHIPMENT_TYPES_CUSTOM: 1,
    SHIPMENT_TYPES_FACTORY_TO_CUSTOMER: 2,
    SHIPMENT_TYPES_USPS: 3,
    SHIPMENT_TYPES_APO: 9,
    SHIPMENT_TYPES_NON_US_TO_US: 10,
    SHIPMENT_TYPES_NON_US_TO_NON_US: 11,
    SHIPMENT_TYPES_US_TO_NON_US: 12,
} as const;
export type ShipmentTypeID = typeof ShipmentTypeID[keyof typeof ShipmentTypeID];

// go/v2/shippingaccounts.go
export declare interface ShippingAccount {
    id?: string;
    carrierID?: CarrierID;
    name?: string;
    accountNumber?: string;
    supportedShipmentTypeIDs?: ShipmentTypeID[];
    active?: boolean;
    created?: string;
    updated?: string;
    carrier?: Carrier;
}

// go/v2/shippingbills.go
export declare interface ShippingBill {
    id?: string;
    shippingInvoiceFileID?: string;
    trackingNumber?: string;
    amount?: string;
    customer?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateID?: StateID;
    zip?: string;
    countryID?: CountryID;
    referenceLine1?: string;
    referenceLine2?: string;
    dateInvoiced?: string;
    dateShipped?: string;
    accountNumber?: string;
    sortableAccountNumber?: string;
    possibleInvoiceNumber?: number;
    ignored?: boolean;
    associated?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    paired?: boolean;
    shipmentID?: string;
    shippingInvoiceFile?: ShippingInvoiceFile;
}

// go/v2/shippinginvoicefiles.go
export declare interface ShippingInvoiceFile {
    id?: string;
    carrierID?: CarrierID;
    accountNumber?: string;
    invoiceDate?: string;
    name?: string;
    file?: string;
    sortableAccountNumber?: string;
    createdByUserID?: string;
    paid?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    carrier?: Carrier;
    createdBy?: User;
    shippingBills?: ShippingBill[];
}

// go/v2/shippingoptions.go
export declare interface ShippingOption {
    id?: string;
    userID?: string;
    addressID?: string;
    addressVersion?: number;
    fullName?: string;
    company?: string;
    email?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateID?: StateID;
    zip?: string;
    phone?: string;
    countryID?: CountryID;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    address?: Address;
    country?: Country;
    state?: State;
}

// go/v2/smstemplates.go
export declare interface SMSTemplate {
    id?: string;
    companyID?: string;
    networkID?: string;
    name?: string;
    text?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}

// go/v2/sparkpostrequests.go
export declare interface SparkPostRequest {
    id?: string;
    userID?: string;
    customerEmailID?: string;
    sentEmailID?: string;
    body?: unknown;
    email?: string;
    type?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
}

// go/v2/stages.go
export declare interface Stage {
    id?: string;
    name?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}

// go/v2/states.go
export declare interface State {
    id?: StateID;
    countryID?: CountryID;
    name?: string;
    stateCode?: string;
    apo?: boolean;
    international?: boolean;
}
export const StateID = {
    STATE_FLORIDA: 9,
    STATE_PUERTO_RICO: 55,
    STATE_GUAM: 53,
    STATE_JIANGSU: 114,
} as const;
export type StateID = typeof StateID[keyof typeof StateID];

// go/v2/static.go
export declare interface StaticFile {
    PageID: string;
    BlogID: string;
    StockItemID: string;
    Source: string;
    OutputFile: string;
    RedirectLocation: string;
    Sitemap: boolean;
    Company: string;
    CompanyID: string;
    CompanyInt: number;
    URL: string;
    Host: string;
}

// go/v2/stockitemcategory.go
export declare interface StockItemCategory {
    id?: string;
    name?: string;
}

// go/v2/stockitemimages.go
export declare interface StockItemImage {
    id?: string;
    networkID?: string;
    path?: string;
    name?: string;
    description?: string;
    files?: StockItemImageFiles;
    totalSize?: number;
    main?: string;
    thumbnail?: string;
    image?: Image;
    stockItem?: StockItem;
}
export declare interface StockItemImageFiles {
    Original?: StockItemImageFile;
    Raster?: StockItemImageFile;
    Thumbnail?: StockItemImageFile;
    Small?: StockItemImageFile;
    Medium?: StockItemImageFile;
    Large?: StockItemImageFile;
}
export declare interface StockItemImageFile {
    File: string;
    Mime: string;
    Size: number;
    Width: number;
    Height: number;
}

// go/v2/stockitems.go
export declare interface StockItem {
    id?: string;
    name?: string;
    pluralName?: string;
    description?: string;
    stockItemImageID?: string;
    weight?: string;
    size?: string;
    price?: string;
    quantity?: number;
    backorder?: boolean;
    quantityPricing?: { [key: number]: string};
    body?: string;
    stockItemCategoryID?: string;
    tags?: string[];
    permalink?: string;
    published?: boolean;
    publishedTime?: string;
    updated?: string;
    created?: string;
    createdByUserID?: string;
    updatedByUserID?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    stockItemCategory?: StockItemCategory;
    stockItemImage?: StockItemImage;
    cartItems?: CartItem[];
    realm?: Realm;
}
export const StockItemID = {
    STOCK_ITEM_CHRISTMAS_ORNAMENT: "Ee1l6m74JJSWWQJCrBIABA",
} as const;
export type StockItemID = typeof StockItemID[keyof typeof StockItemID];
export declare interface QuantityPrice {
    Quantity: number;
    Price: string;
}

// go/v2/stockitemuploads.go
export declare interface StockItemUpload {
    id?: string;
    stockItemID?: string;
    uploadID?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    stockItem?: StockItem;
    upload?: Upload;
    createdBy?: User;
}

// go/v2/system.go
export declare interface FullProcessList {
    id?: number;
    user?: string;
    host?: string;
    db?: string;
    command?: string;
    time?: number;
    state?: string;
    info?: string;
    rowsSent?: number;
    rowsExamined?: number;
}

// go/v2/tableviews.go
export declare interface TableView {
    id?: string;
    name?: string;
    page?: string;
    query?: string;
    sort?: string;
    visibleColumns?: string[];
    pageSize?: number;
    shared?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    createdBy?: User;
}

// go/v2/uploads.go
export declare interface Upload {
    id?: number;
    companyID?: string;
    name?: string;
    mime?: string;
    tmpKey?: string;
    key?: string;
    size?: number;
    'sha3-224'?: string;
    region?: string;
    text?: string;
    hasRekognition?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    tags?: string[];
    company?: Realm;
    createdBy?: User;
    uploadRekognitionLabels?: UploadRekognitionLabel[];
    uploadTags?: UploadTag[];
    uploadDetailRows?: UploadDetail[];
    uploadDetails?: UploadDetails;
}
export declare interface UploadDetail {
    id?: string;
    uploadID?: number;
    name?: string;
    value?: unknown;
    createdByUserID?: string;
    updatedByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
export declare interface UploadDetails {
    lineItem?: string;
    type?: string;
    size?: string;
    plating?: string;
    edge?: string;
    industry?: string;
    attachment?: string;
    lanyardColor?: string;
    manufacturingLocation?: string;
}
export declare interface UploadRekognitionLabel {
    id?: number;
    uploadID?: number;
    label?: string;
    moderation?: boolean;
    confidence?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    upload?: Upload;
}

// go/v2/uploadtags.go
export declare interface UploadTag {
    id?: string;
    uploadID?: number;
    tag?: string;
    tagMurmur?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    upload?: Upload;
    createdBy?: User;
}

// go/v2/useradminroles.go
export declare interface UserAdminRole {
    id?: string;
    adminRoleID?: AdminRoleID;
    userID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    adminRole?: AdminRole;
}

// go/v2/userassociations.go
export declare interface UserAssociation {
    id?: string;
    userID?: string;
    associatedUserID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    associatedUser?: User;
    createdBy?: User;
}

// go/v2/usercompanies.go
export declare interface UserCompany {
    id?: string;
    userID?: string;
    companyID?: string;
    dateTimeAdded?: string;
    company?: Realm;
}

// go/v2/userevents.go
export declare interface UserEvent {
    buuid?: string;
    id?: string;
    userID?: string;
    userEventTypeID?: number;
    quoteRequestProjectTaskID?: string;
    content?: string;
    contentType?: string;
    icon?: string;
    color?: string;
    pinned?: boolean;
    automated?: boolean;
    remind?: string;
    updated?: string;
    orderNotes?: boolean;
    friday?: boolean;
    small?: boolean;
    phoned?: boolean;
    customerRequest?: boolean;
    hiddenForArtists?: boolean;
    point?: {
        x: number;
        y: number;
    };
    pointNumber?: number;
    createdByUserID?: string;
    companyID?: string;
    created?: string;
    userEventUploads?: UserEventUpload[];
    company?: Realm;
    user?: User;
    createdBy?: User;
}

// go/v2/usereventuploads.go
export declare interface UserEventUpload {
    id?: string;
    userEventID?: string;
    uploadID?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    upload?: Upload;
}

// go/v2/userfactories.go
export declare interface UserFactory {
    id?: number;
    factoryID?: string;
    originalFactoryID?: string;
    userID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    factory?: Factory;
}

// go/v2/usermanagingcompanies.go
export declare interface UserManagingCompany {
    id?: string;
    managingCompanyID?: string;
    userID?: string;
    created?: string;
    active?: boolean;
    managingCompany?: ManagingCompany;
}

// go/v2/usernetworks.go
export declare interface UserNetwork {
    id?: string;
    userID?: string;
    networkID?: string;
    created?: string;
    network?: Network;
}

// go/v2/userorderbids.go
export declare interface UserOrderBid {
    id?: string;
    userID?: string;
    orderID?: string;
    factoryID?: string;
    read?: boolean;
    submitted?: boolean;
    ignored?: boolean;
    factoryConfirmedShipDate?: string;
    accepted?: string;
    cachedCost?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    userOrderLineItemBids?: UserOrderLineItemBid[];
    userOrderChildLineItemBids?: UserOrderChildLineItemBid[];
    order?: Order;
    user?: User;
}

// go/v2/userorderchildlineitembids.go
export declare interface UserOrderChildLineItemBid {
    id?: string;
    userOrderBidID?: string;
    orderChildLineItemID?: string;
    cost?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orderChildLineItem?: OrderChildLineItem;
}

// go/v2/userorderlineitembids.go
export declare interface UserOrderLineItemBid {
    id?: string;
    userOrderBidID?: string;
    orderLineItemID?: string;
    cost?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orderLineItem?: OrderLineItem;
}

// go/v2/userpermissions.go
export declare interface UserPermission {
    id?: string;
    permissionID?: string;
    userID?: string;
    created?: string;
}

// go/v2/userquoteimages.go
export declare interface UserQuoteImage {
    id?: string;
    userID?: string;
    imageID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    image?: Image;
    createdBy?: User;
}

// go/v2/userquoterequestreads.go
export declare interface UserQuoteRequestRead {
    id?: string;
    userID?: string;
    quoteRequestID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    quoteRequest?: QuoteRequest;
}

// go/v2/userquotesccs.go
export declare interface UserQuotesCC {
    id?: string;
    userID?: string;
    email?: string;
    sortOrder?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    createdBy?: User;
}

// go/v2/userquotesemails.go
export declare interface UserQuotesEmail {
    id?: string;
    userID?: string;
    email?: string;
    sortOrder?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    createdBy?: User;
}

// go/v2/userroleoptions.go
export declare interface UserRoleOption {
    id?: number;
    name?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/users.go
export declare interface User {
    id?: string;
    companyID?: string;
    userRoleOptionID?: number;
    salesTeamID?: string;
    originalSalesTeamID?: string;
    pageRequestID?: string;
    email?: string;
    phone?: string;
    firstName?: string;
    lastName?: string;
    company?: string;
    balance?: string;
    lastCustomerContact?: string;
    created?: string;
    permissions?: string[];
    active?: boolean;
    darkMode?: boolean;
    color?: string;
    contactedRX?: string;
    contactedTX?: string;
    phoneRFC3966?: string;
    signature?: string;
    helpScoutUserID?: number;
    imageID?: string;
    countryID?: CountryID;
    stateID?: StateID;
    tz?: string;
    quotesName?: string;
    quoteMessageID?: string;
    quotesMessage?: string;
    quotesContentType?: string;
    quotesSubject?: string;
    qboCustomerID?: string;
    loginToken?: string;
    passwordHash?: string;
    passwordVersion?: number;
    uploadID?: number;
    realm?: Realm;
    contacts?: Contact[];
    quoteRequests?: QuoteRequest[];
    quoteRequestProjects?: QuoteRequestProject[];
    orders?: Order[];
    userRoleOption?: UserRoleOption;
    receivedEmails?: ReceivedEmail[];
    userAdminRoles?: UserAdminRole[];
    userFactories?: UserFactory[];
    userNetworks?: UserNetwork[];
    userCompanies?: UserCompany[];
    userManagingCompanies?: UserManagingCompany[];
    salesTeamUsers?: SalesTeamUser[];
    country?: Country;
    state?: State;
    flagFlags?: FlagFlag[];
    upload?: Upload;
    image?: Image;
    userQuotesEmails?: UserQuotesEmail[];
    userQuotesCCs?: UserQuotesCC[];
    salesTeam?: SalesTeam;
    quoteMessage?: QuoteMessage;
    userQuoteImages?: UserQuoteImage[];
    userEvents?: UserEvent[];
    pageRequests?: PageRequest[];
    userDetails?: UserDetails;
    rawUserDetails?: UserDetail[];
}
export declare interface UserDetail {
    id?: string;
    userID?: string;
    name?: string;
    value?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
export declare interface UserDetails {
    activationKey: string;
    iapDefaultQuotesPage: string;
    ignoreArtistStats: string;
    startDate: string;
    hoursWorkedPerWeek: string;
}

// go/v2/usertaxexemptionapprovals.go
export declare interface UserTaxExemptionApproval {
    id?: string;
    userTaxExemptionID?: string;
    level?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}

// go/v2/usertaxexemptionorders.go
export declare interface UserTaxExemptionOrder {
    id?: string;
    userTaxExemptionID?: string;
    orderID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
    order?: Order;
    userTaxExemption?: UserTaxExemption;
}

// go/v2/usertaxexemptionreasons.go
export declare interface UserTaxExemptionReason {
    id?: UserTaxExemptionReasonID;
    name?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}
export const UserTaxExemptionReasonID = {
    USER_TAX_EXEMPTION_REASON_ENTITY_EXEMPT: 1,
    USER_TAX_EXEMPTION_REASON_GOVERNMENT_EXEMPTION: 2,
    USER_TAX_EXEMPTION_REASON_WHOLESALE_OR_RETAIL_EXEMPTION: 3,
} as const;
export type UserTaxExemptionReasonID = typeof UserTaxExemptionReasonID[keyof typeof UserTaxExemptionReasonID];

// go/v2/usertaxexemptions.go
export declare interface UserTaxExemption {
    id?: string;
    userID?: string;
    userTaxExemptionReasonID?: UserTaxExemptionReasonID;
    countryID?: CountryID;
    stateID?: StateID;
    number?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    userTaxExemptionReason?: UserTaxExemptionReason;
    userTaxExemptionOrders?: UserTaxExemptionOrder[];
    userTaxExemptionUploads?: UserTaxExemptionUpload[];
    userTaxExemptionApprovals?: UserTaxExemptionApproval[];
    country?: Country;
    state?: State;
    createdBy?: User;
}

// go/v2/usertaxexemptionuploads.go
export declare interface UserTaxExemptionUpload {
    id?: string;
    userTaxExemptionID?: string;
    uploadID?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
    upload?: Upload;
}

// go/log/log.go
export declare interface LogEntry {
    id?: number;
    ip?: string;
    description?: string;
    meta?: string;
    level?: LogLevel;
    options?: LogOptions;
    createdByUserID?: string;
    created?: string;
    user?: LogUser;
}
export declare interface LogUser {
    firstName?: string;
    lastName?: string;
}
export const LogLevel = {
    LOG_LEVEL_INFO: 0,
    LOG_LEVEL_NOTICE: 1,
    LOG_LEVEL_WARN: 2,
    LOG_LEVEL_ERROR: 3,
} as const;
export type LogLevel = typeof LogLevel[keyof typeof LogLevel];
export const LogOptions = {
    LOG_OPTION_MARKDOWN: 1<<1,
    LOG_OPTION_HTML: 1<<3,
    LOG_OPTION_S_3: 1<<4,
    LOG_OPTION_GZIP: 1<<5,
    LOG_OPTION_CLIENT_SIDE: 1<<6,
} as const;
export type LogOptions = typeof LogOptions[keyof typeof LogOptions];
